import React, { Component } from 'react';
import { FixedSizeList as List } from 'react-window';
import styled from 'styled-components';
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  Card,
  Typography,
  Tabs,
  Upload,
  Checkbox,
  Space,
  InputNumber,
  Switch,
  Tag,
  Tooltip,
  Avatar,
  Collapse,
  FloatButton,
  Flex,
  Radio,
  Tour,
  DatePicker,
  message
} from 'antd';
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  RedoOutlined,
  PlusCircleOutlined,
  PlusCircleFilled,
  CheckCircleOutlined,
  StopFilled,
  CloseCircleOutlined,
  RocketFilled,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  CaretRightOutlined,
  RightCircleFilled,
  ArrowLeftOutlined,
  CommentOutlined,
  CustomerServiceOutlined,
  SwapRightOutlined,
  InfoCircleFilled,
  EditFilled,
  AppstoreFilled,
  MinusCircleFilled,
  DownloadOutlined
} from '@ant-design/icons';
import { ButtonSquare } from 'src/components/elements/Button';
import dropImage from 'src/static/icons/carImageUpload/placeholder.png';
import placeholderImg from 'src/static/no-image.png';
import Resizer from 'react-image-file-resizer';
import { Form } from '@ant-design/compatible';
import { resolveSelectedSite } from 'src/utils/selectedSite';
import { withIsMobile } from 'src/utils/responsive';
import Notify from 'src/components/meta/Notification';
import Highlighter from 'react-highlight-words';
// import moment from 'moment';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import XLSX from 'sheetjs-style';
import { saveAs } from 'file-saver';

dayjs.extend(utc);
dayjs.extend(timezone);

const { Dragger } = Upload;
const { Search } = Input;
const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;
const { TextArea } = Input;
const { TabPane } = Tabs;

const { Option } = Select;
const Cards = styled(Card)`
  .ant-card .ant-card-body {
    padding-left: 0px !important;
    padding-bottom: 3em !important;
  }

  @media (max-width: 991px) {
    width: 100%;
    min-width: 0;
    margin-bottom: 1em;

    > .ant-card-head {
      min-height: auto;
      padding: 0.9em 1em;
      border-bottom: 1px solid #edf1ee;
    }
    .ant-card-head-wrapper {
      flex-wrap: wrap;
      gap: 0.5em;
    }
    .ant-card-extra {
      width: 100%;
      margin-left: 0;
    }
    > .ant-card-body {
      padding: 1em !important;
      padding-bottom: 6em !important;
    }
  }
`;
const ImageCards = styled(Card)`
  .ant-card .ant-card-body {
    display: none !important;
  }
`;
// The add/edit form lays its fields out in fixed span={3..6} columns, which are
// unusable on a phone. Rather than annotate ~33 columns individually, collapse
// every column inside the form to full width below the shell's breakpoint and
// pull in the 2em row padding. !important is needed to beat the inline styles.
const ResponsiveFormWrap = styled.span`
  @media (max-width: 991px) {
    display: block;
    width: 100%;
    min-width: 0;

    .ant-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 1em !important;
      padding-right: 1em !important;
    }
    .ant-form-item {
      margin-bottom: 1em;
    }
    .ant-input,
    .ant-input-number,
    .ant-picker,
    .ant-select,
    .ant-upload,
    .ant-upload-select {
      width: 100% !important;
      max-width: 100% !important;
    }
    .ant-input,
    .ant-picker,
    .ant-input-number,
    .ant-select-selector {
      min-height: 44px !important;
      border-radius: 8px !important;
    }
    .ant-input,
    .ant-picker-input > input,
    .ant-input-number-input,
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      font-size: 16px !important;
    }
    .ant-input-number-input {
      height: 42px;
    }
    textarea.ant-input {
      min-height: 96px !important;
    }
    .ant-form-item-label {
      padding-bottom: 0.3em;
    }
    .ant-form-item-label > label {
      height: auto;
      white-space: normal;
      line-height: 1.3;
    }
    .ant-divider {
      margin: 0.75em 0 1em;
      color: #35553d;
      font-weight: 800;
    }
    .ant-collapse {
      overflow: hidden;
      border: 1px solid #e4ece6 !important;
      border-radius: 10px;
      background: #fff;
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
      align-items: center;
      min-height: 48px;
      padding: 0.8em 1em !important;
      background: #f4f8f5;
      color: #35553d;
      font-weight: 700;
    }
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0.8em 0 0 !important;
    }
    .mobile-line-item {
      margin: 0 0 0.9em !important;
      padding: 1em !important;
      border: 1px solid #dfe9e2 !important;
      border-radius: 10px;
      background: #fbfdfb;
      box-shadow: 0 3px 10px rgba(31, 61, 38, 0.05);
    }
    .mobile-line-item .ant-col {
      margin-top: 0 !important;
    }
    .mobile-line-item .ant-btn {
      width: 100%;
      min-height: 44px;
      margin-top: 0;
    }
    .mobile-add-row {
      padding: 0 1em 1em !important;
      border-top: 0 !important;
    }
    .mobile-add-row .ant-btn {
      width: 100% !important;
      min-height: 44px;
      border-radius: 8px;
    }
    .ant-upload-wrapper,
    .ant-upload-list,
    .ant-upload-select {
      max-width: 100%;
    }
  }
`;
const MobileEditActions = styled.div`
  display: none;

  @media (max-width: 991px) {
    position: fixed;
    right: 1em;
    bottom: 0.5em;
    bottom: calc(0.5em + env(safe-area-inset-bottom));
    left: 1em;
    z-index: 50;
    display: flex;
    gap: 0.65em;
    margin: 0;
    padding: 0.65em;
    background: rgba(255, 255, 255, 0.94);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.8em;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
    backdrop-filter: blur(8px);

    .ant-btn {
      flex: 1 1 0;
      height: 44px;
      border-radius: 0.65em;
      font-weight: 700;
    }
  }
`;
const modules = {
  toolbar: [
    // [{ header: '1' }, { header: '2' }, { font: [] }],
    // [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    // ['link', 'image', 'video'],
    ['link'],
    ['clean']
  ],
  clipboard: {
    // toggle to add extra line breaks when mirrorsing HTML:
    matchVisual: true
  }
};
const StyledTable = styled(Table)`
  //   .ant-table-thead > tr > th {
  //     color: white !important;
  //     background: #1C1C1C !important;
  //   }
  // .ant-table-wrapper .ant-table-filter-trigger
  //   {
  //     margin-right:1em!important;
  //     color: white !important;
  //     background: #00b2067c !important;
  //   }
  //   .ant-table-tbody > tr > td {
  //     border-bottom: 1px solid #f0f0f0;
  //     transition: background 0.3s;
  //     font-weight: 500;
  //     color: #525f7f;
  //     font-size: 15px;
  //   }

  /* These tables carry 8-12 columns. Below the shell's mobile breakpoint let
     them scroll sideways instead of crushing every column to unreadable width.
     Applied here rather than per-table so all 16 usages, nested expanded rows
     included, get it. */
  @media (max-width: 991px) {
    .ant-table-content,
    .ant-table-body {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-x pan-y;
      scrollbar-width: thin;
      scrollbar-color: #80ce90 #eef2ef;
    }
    .ant-table-content::-webkit-scrollbar,
    .ant-table-body::-webkit-scrollbar {
      height: 8px;
    }
    .ant-table-content::-webkit-scrollbar-track,
    .ant-table-body::-webkit-scrollbar-track {
      background: #eef2ef;
      border-radius: 999px;
    }
    .ant-table-content::-webkit-scrollbar-thumb,
    .ant-table-body::-webkit-scrollbar-thumb {
      background: #80ce90;
      border-radius: 999px;
    }
    .ant-table table {
      min-width: 40em;
    }
    .ant-table-thead > tr > th {
      white-space: nowrap;
    }
    .ant-table-cell-fix-right {
      background: #fff;
      box-shadow: -5px 0 10px rgba(0, 0, 0, 0.06);
    }
    .ant-table-tbody > tr > td {
      padding: 10px 12px;
    }
    .ant-table-tbody .ant-table-cell-fix-right .anticon {
      min-width: 36px;
      min-height: 36px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .ant-table-row-expand-icon {
      width: 30px !important;
      height: 30px !important;
      min-width: 30px;
      min-height: 30px;
      border: 1px solid rgba(128, 206, 144, 0.65) !important;
      border-radius: 50% !important;
      background: #f3fff6 !important;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }
    .ant-table-row-expand-icon::before {
      top: 13px !important;
      right: 7px !important;
      left: 7px !important;
      height: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon::after {
      top: 7px !important;
      bottom: 7px !important;
      left: 13px !important;
      width: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon-cell {
      position: sticky !important;
      left: 0;
      z-index: 3;
      background: #fff !important;
    }
    .ant-table-container {
      overflow: hidden;
      border: 1px solid #e3ebe5;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 4px 14px rgba(31, 61, 38, 0.06);
    }
    &.compact-mobile-table .ant-table table {
      min-width: 100%;
    }
    .ant-table-thead > tr > th {
      padding: 10px 12px;
      background: #fafafa !important;
      color: #262626 !important;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.02em;
    }
    .ant-table-tbody > tr > td {
      font-size: 13px;
      line-height: 1.35;
    }
    .ant-table-tbody > tr:nth-child(even):not(.ant-table-expanded-row) > td {
      background: #fbfcfb;
    }
    .ant-table-expanded-row > td {
      padding: 8px !important;
      background: #eff6f1 !important;
    }
    .ant-table-expanded-row .ant-table-wrapper {
      margin: 0 !important;
    }
    .ant-table-cell-fix-right {
      z-index: 4;
    }
    .ant-table-thead .ant-table-cell-fix-right {
      background: #fafafa !important;
      z-index: 6;
    }
    .ant-table-row-expand-icon {
      cursor: pointer;
      transition: background 0.2s ease, border-color 0.2s ease,
        transform 0.2s ease;
    }
    .ant-table-row-expand-icon-cell {
      width: 48px;
      min-width: 48px;
      max-width: 48px;
      padding: 8px !important;
      z-index: 5;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell {
      background: #fafafa !important;
      z-index: 7;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th,
    .ant-table-tbody > tr > .ant-table-row-expand-icon-cell + td {
      position: sticky !important;
      left: 48px;
      z-index: 4;
      background: #fff !important;
      box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th {
      background: #fafafa !important;
      color: #262626 !important;
      z-index: 6;
    }
    .ant-table-tbody
      > tr:nth-child(even):not(.ant-table-expanded-row)
      > .ant-table-row-expand-icon-cell + td {
      background: #fbfcfb !important;
    }
    .ant-pagination {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      row-gap: 0.5em;
    }
  }
`;
const StyledTableExpanded = styled(Table)`
  .ant-table-thead > tr > th {
    color: #525f7f !important;
    background: rgba(0, 0, 0, 0.02) !important;
  }
  .ant-table-wrapper .ant-table-filter-trigger {
    margin-right: 1em !important;
    color: white !important;
    background: #00b2067c !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;
    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }

  @media (max-width: 991px) {
    .ant-table-content,
    .ant-table-body {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch;
      touch-action: pan-x pan-y;
      scrollbar-width: thin;
      scrollbar-color: #80ce90 #eef2ef;
    }
    .ant-table-content::-webkit-scrollbar,
    .ant-table-body::-webkit-scrollbar {
      height: 8px;
    }
    .ant-table-content::-webkit-scrollbar-track,
    .ant-table-body::-webkit-scrollbar-track {
      background: #eef2ef;
      border-radius: 999px;
    }
    .ant-table-content::-webkit-scrollbar-thumb,
    .ant-table-body::-webkit-scrollbar-thumb {
      background: #80ce90;
      border-radius: 999px;
    }
    .ant-table table {
      min-width: 40em;
    }
    .ant-table-thead > tr > th {
      white-space: nowrap;
    }
    .ant-table-cell-fix-right {
      background: #fff;
      box-shadow: -5px 0 10px rgba(0, 0, 0, 0.06);
    }
    .ant-table-tbody > tr > td {
      padding: 10px 12px;
    }
    .ant-table-tbody .ant-table-cell-fix-right .anticon {
      min-width: 36px;
      min-height: 36px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .ant-table-row-expand-icon {
      width: 30px !important;
      height: 30px !important;
      min-width: 30px;
      min-height: 30px;
      border: 1px solid rgba(128, 206, 144, 0.65) !important;
      border-radius: 50% !important;
      background: #f3fff6 !important;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }
    .ant-table-row-expand-icon::before {
      top: 13px !important;
      right: 7px !important;
      left: 7px !important;
      height: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon::after {
      top: 7px !important;
      bottom: 7px !important;
      left: 13px !important;
      width: 2px !important;
      background: #80ce90 !important;
    }
    .ant-table-row-expand-icon-cell {
      position: sticky !important;
      left: 0;
      z-index: 3;
      background: #fff !important;
    }
    .ant-table-container {
      overflow: hidden;
      border: 1px solid #dce8df;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 3px 10px rgba(31, 61, 38, 0.05);
    }
    &.compact-mobile-table .ant-table table {
      min-width: 100%;
    }
    .ant-table-thead > tr > th {
      padding: 10px 12px;
      background: #fafafa !important;
      color: #262626 !important;
      font-size: 12px;
      font-weight: 700;
    }
    .ant-table-tbody > tr > td {
      font-size: 13px;
      line-height: 1.35;
    }
    .ant-table-tbody > tr:nth-child(even):not(.ant-table-expanded-row) > td {
      background: #fbfcfb;
    }
    .ant-table-expanded-row > td {
      padding: 8px !important;
      background: #e7f1e9 !important;
    }
    .ant-table-expanded-row .ant-table-wrapper {
      margin: 0 !important;
    }
    .ant-table-cell-fix-right {
      z-index: 4;
    }
    .ant-table-thead .ant-table-cell-fix-right {
      background: #fafafa !important;
      z-index: 6;
    }
    .ant-table-row-expand-icon {
      cursor: pointer;
      transition: background 0.2s ease, border-color 0.2s ease,
        transform 0.2s ease;
    }
    .ant-table-row-expand-icon-cell {
      width: 48px;
      min-width: 48px;
      max-width: 48px;
      padding: 8px !important;
      z-index: 5;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell {
      background: #fafafa !important;
      z-index: 7;
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th,
    .ant-table-tbody > tr > .ant-table-row-expand-icon-cell + td {
      position: sticky !important;
      left: 48px;
      z-index: 4;
      background: #fff !important;
      box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    }
    .ant-table-thead > tr > .ant-table-row-expand-icon-cell + th {
      background: #fafafa !important;
      color: #262626 !important;
      z-index: 6;
    }
    .ant-table-tbody
      > tr:nth-child(even):not(.ant-table-expanded-row)
      > .ant-table-row-expand-icon-cell + td {
      background: #fbfcfb !important;
    }
  }
`;
const MobileTableHelp = styled.div`
  display: none;

  @media (max-width: 991px) {
    display: flex;
    align-items: center;
    gap: 0.55em;
    margin-top: 1em;
    padding: 0.65em 0.8em;
    border: 1px solid rgba(128, 206, 144, 0.45);
    border-radius: 10px;
    background: #f3faf5;
    color: #42624a;
    font-size: 12px;
    line-height: 1.35;

    strong {
      flex: 0 0 auto;
      padding: 0.25em 0.45em;
      border-radius: 5px;
      background: #dff2e3;
      color: #2f7e43;
      font-size: 10px;
      letter-spacing: 0.04em;
    }
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }

  @media (max-width: 991px) {
    &.stock-management-tabs > .ant-tabs-nav > .ant-tabs-nav-wrap {
      display: none;
    }
    .ant-tabs-nav {
      flex-wrap: wrap;
      gap: 0.5em;
      margin-bottom: 0.75em;
    }
    .ant-tabs-nav-wrap {
      width: 100%;
      overflow-x: auto;
    }
    .ant-tabs-nav-list {
      min-width: max-content;
    }
    .ant-tabs-tab {
      padding: 0.65em 0.8em;
    }
    .ant-tabs-extra-content {
      width: 100%;
      margin-left: 0 !important;
    }
    &.edit-form-tabs {
      width: 100%;
      min-width: 0;
      margin: 0 !important;
    }
    &.edit-form-tabs > .ant-tabs-nav {
      position: sticky;
      top: 56px;
      z-index: 12;
      width: 100%;
      margin: 0 0 0.75em;
      padding: 0.35em;
      border: 1px solid #dfe9e2;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.96);
      box-shadow: 0 4px 12px rgba(31, 61, 38, 0.08);
      backdrop-filter: blur(8px);
    }
    &.edit-form-tabs > .ant-tabs-nav .ant-tabs-nav-list {
      width: 100%;
      min-width: 0;
    }
    &.edit-form-tabs > .ant-tabs-nav .ant-tabs-tab {
      flex: 1 1 auto;
      justify-content: center;
      min-height: 40px;
      margin: 0 !important;
      border: 0 !important;
      border-radius: 7px !important;
      background: #f2f6f3;
      font-weight: 800;
    }
    &.edit-form-tabs > .ant-tabs-nav .ant-tabs-tab-active {
      background: #def1e2;
    }
    &.edit-form-tabs > .ant-tabs-content-holder {
      min-width: 0;
      margin-left: 0 !important;
      border-left: 0 !important;
    }
    &.edit-form-tabs .ant-tabs-tabpane {
      min-width: 0;
      padding-left: 0 !important;
    }
  }
`;
const StockFilters = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;

    .stock-site-filter,
    .stock-month-filter {
      order: 1;
      width: 100% !important;
      margin: 0 !important;
    }
    .stock-pax-filter,
    .stock-year-filter {
      order: 2;
      width: calc(50% - 0.25em) !important;
      margin: 0 !important;
    }
    .stock-pax-filter {
      min-height: 40px;
      display: flex !important;
      align-items: center;
      justify-content: center;
    }
    .stock-month-filter {
      order: 3;
    }
  }
`;
const MobileStockNavigation = styled(Radio.Group)`
  display: none;

  @media (max-width: 991px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5em;
    margin: 0.75em 0;

    .ant-radio-button-wrapper {
      width: 100%;
      height: 42px;
      padding: 0 0.5em;
      border: 1px solid #d9e2dc !important;
      border-radius: 0.7em !important;
      line-height: 40px;
      text-align: center;
      font-weight: 700;
      color: #3f4f45;
      box-shadow: none;
    }
    .ant-radio-button-wrapper::before {
      display: none !important;
    }
    .ant-radio-button-wrapper-checked {
      color: #fff !important;
      background: #80ce90 !important;
      border-color: #80ce90 !important;
      box-shadow: 0 3px 8px rgba(52, 143, 77, 0.24) !important;
    }
  }
`;

const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;
const StyledInput = styled(Input)``;
const StyledInputNumber = styled(InputNumber)`
  // padding-left: 1.2em !important;
  // font-weight: 500 !important;
  // color: #525f7f !important;
  // font-size: 15px !important;
  // height: 47px !important;
  // border-right-width: 0px !important;
  //   box-shadow:none !important;
  // background-color: white!important;
  // background-image: none;
  // border: none;
  // border: 0px solid black !important;
  // border-bottom: 1px solid lightgrey !important;
  // border-radius: 0px;
  // color: black!important;
  // //box-shadow: rgba(0, 0, 0, 0.11) 2px 8px 13px 5px !important;
  // :placeholder {
  //   color: lightgrey !important;
  // }
  // :hover {
  //   border-color: red !important;
  //   border-right-width: 0px !important;
  //   box-shadow:none !important;
  // }
  // :active{
  //   border-color: red !important;
  //   border-right-width: 0px !important;
  //    box-shadow:none !important;

  // }
  // :focus{
  //   border-color: red !important;
  //   border-right-width: 0px !important;
  //    box-shadow:none !important;

  // }
  // }
`;
const StyledSelect = styled(Select)``;
function callback(key) {}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class AddStockForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: dayjs().format('YYYY'),
      isRefunded:
        this.props.editStock && this.props.editStock.isRefunded ? true : false,
      // isRefunded: true,
      previewVisible: false,
      costVisible: false,
      roomsVisible: false,
      previewVisibleVariant: false,
      previewImage: '',
      previewTitle: '',
      fileList: [],
      mainProductImageAlt1: undefined,
      mainProductImage: undefined,
      mainProductImageAlt2: undefined,
      disabled: true,
      salesRows: [
        {
          id: 0,
          extraSales: undefined,
          saleRefund: undefined,
          saleCategory: undefined,
          saleComments: undefined
        }
      ],
      costRows: [
        {
          id: 0,
          costPrice: undefined,
          costPerPerson: undefined,
          costCategory: undefined,
          costComments: undefined
        }
      ],
      compRows: [
        {
          id: 0,
          compCategory: undefined,
          compDescription: undefined,
          compValue: undefined,
          compGuest: undefined,
          compBookingNr: undefined,
          compComments: undefined
        }
      ],
      removedRows: [], // Track removed row IDs
      removedRowsCost: [], // Track removed row IDs
      removedRowsComp: [], // Track removed row IDs

      // Track multiple salesRows in edit mode
      curDT: new Date().toLocaleString()
    };
    // this.handlePriceChange = this.handlePriceChange.bind(this);
    // this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleAddRow = () => {
    this.setState(
      prevState => {
        const maxId = prevState.salesRows.length
          ? Math.max(...prevState.salesRows.map(row => row.id))
          : 0;

        const newRow = {
          id: maxId + 1,
          extraSales: undefined,
          saleCategory: undefined,
          saleComments: undefined,

          saleRefund: undefined
        };

        console.log('Adding Row:', newRow);
        console.log('Rows before adding:', prevState.salesRows);

        return {
          salesRows: [...prevState.salesRows, newRow]
        };
      },
      () => {
        console.log('Rows after adding:', this.state.salesRows);
      }
    );
  };

  handleRemoveRow = id => {
    this.setState(
      prevState => ({
        salesRows: prevState.salesRows.filter(row => row.id !== id),
        removedRows: [...prevState.removedRows, id] // Track removed salesRows
      }),
      () => {
        console.log('Rows after removal:', this.state.salesRows);
        console.log('Removed Rows:', this.state.removedRows);
      }
    );
  };

  handleAddRowCost = () => {
    this.setState(
      prevState => {
        const maxId = prevState.costRows.length
          ? Math.max(...prevState.costRows.map(row => row.id))
          : 0;

        const newRow = {
          id: maxId + 1,
          costPrice: undefined,
          costCategory: undefined,
          costComments: undefined,
          costPerPerson: undefined
        };

        console.log('Adding Row:', newRow);
        console.log('Rows before adding:', prevState.costRows);

        return {
          costRows: [...prevState.costRows, newRow]
        };
      },
      () => {
        console.log('Rows after adding:', this.state.costRows);
      }
    );
  };

  handleRemoveRowCost = id => {
    this.setState(
      prevState => ({
        costRows: prevState.costRows.filter(row => row.id !== id),
        removedRowsCost: [...prevState.removedRowsCost, id] // Track removed salesRows
      }),
      () => {
        console.log('Rows after removal:', this.state.costRows);
        console.log('Removed Rows:', this.state.removedRowsCost);
      }
    );
  };

  handleAddRowComp = () => {
    this.setState(prevState => {
      const maxId = prevState.compRows.length
        ? Math.max(...prevState.compRows.map(row => row.id))
        : 0;

      return {
        compRows: [
          ...prevState.compRows,
          {
            id: maxId + 1,
            compCategory: undefined,
            compDescription: undefined,
            compValue: undefined,
            compGuest: undefined,
            compBookingNr: undefined,
            compComments: undefined
          }
        ]
      };
    });
  };

  handleRemoveRowComp = id => {
    this.setState(prevState => ({
      compRows: prevState.compRows.filter(row => row.id !== id),
      removedRowsComp: [...prevState.removedRowsComp, id]
    }));
  };

  toggleDisabled = () => {
    this.setState({
      disabled: !this.state.disabled
    });
  };
  handleCancel = () =>
    this.setState({
      previewVisible: false,
      costVisible: false,
      roomsVisible: false,
      previewVisibleVariant: false
    });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    });
  };
  handleChange = ({ fileList }) => this.setState({ fileList });

  selectisRefunded = checked => {
    this.setState({
      isRefunded: !checked ? false : true
    });
  };

  componentDidMount = () => {
    if (this.props.editStock) {
      const {
        cardSales = [],
        cashSales = [],
        extraSales = [],
        extraSalesExchange = [],
        saleCategory = [],
        costCurrency = [],
        saleComments = [],
        saleRefund = [],
        costPrice = [],
        costCategory = [],
        costComments = [],
        costPerPerson = [],
        compCategory = [],
        compDescription = [],
        compValue = [],
        compGuest = [],
        compBookingNr = [],
        compComments = []
      } = this.props.editStock;

      // Filter out salesRows whose IDs are in removedRows
      const salesRows = extraSales
        .map((_, index) => ({
          id: index,
          cashSales: cashSales[index] ?? undefined,
          cardSales: cardSales[index] ?? undefined,
          extraSales: extraSales[index] ?? undefined,
          extraSalesExchange: extraSalesExchange[index] ?? undefined,
          saleCategory: saleCategory[index] ?? undefined,
          costCurrency: costCurrency[index] ?? undefined,
          saleComments: saleComments[index] ?? undefined,
          saleRefund: saleRefund[index] ?? undefined
        }))
        .filter(row => !this.state.removedRows.includes(row.id)); // Exclude removed salesRows

      const costRows = costPrice
        .map((_, index) => ({
          id: index,
          costPrice: costPrice[index] ?? undefined,
          costCategory: costCategory[index] ?? undefined,
          costComments: costComments[index] ?? undefined,
          costPerPerson: costPerPerson[index] ?? undefined
        }))
        .filter(row => !this.state.removedRowsCost.includes(row.id)); // Exclude removed salesRows

      // Complimentary line items. Keyed off compValue so a row with only a
      // description but no value still round-trips; fall back to whichever
      // array actually has entries.
      const compLength = Math.max(
        compValue.length,
        compCategory.length,
        compDescription.length
      );
      const compRows = Array.from({ length: compLength })
        .map((_, index) => ({
          id: index,
          compCategory: compCategory[index] ?? undefined,
          compDescription: compDescription[index] ?? undefined,
          compValue: compValue[index] ?? undefined,
          compGuest: compGuest[index] ?? undefined,
          compBookingNr: compBookingNr[index] ?? undefined,
          compComments: compComments[index] ?? undefined
        }))
        .filter(row => !this.state.removedRowsComp.includes(row.id));

      this.setState(
        {
          costRows,
          salesRows,
          ...(compRows.length ? { compRows } : {})
        },
        () => {
          console.log(
            'Rows initialized in componentDidMount:',
            this.state.salesRows
          );
        }
      );
    }
  };
  handleMainProductImageAlt1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainProductImageAlt1: imageUrl
      });
    });
  };
  handleMainProductImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainProductImage: imageUrl
      });
    });
  };
  handleMainProductImageAlt2 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainProductImageAlt2: imageUrl
      });
    });
  };

  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };

  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1200, 1200, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };

  // Handle date change
  handleDateChange = date => {
    if (!date) {
      return;
    }

    const selectedDate = dayjs(date)
      .startOf('day')
      .toISOString(); // Normalize to the start of the day

    // Find matching room data by date
    const matchingRoom = this.props.stock.find(item => {
      if (!item.roomsDate) {
        console.warn(`roomsDate is undefined for Stock Item ID: ${item._id}`);
        return false; // Skip this item
      }
      const roomDate = dayjs(item.roomsDate)
        .startOf('day')
        .toISOString();

      return roomDate === selectedDate;
    });

    if (matchingRoom) {
      this.props.form.setFieldsValue({
        costRoomsAvail:
          matchingRoom.roomsAvail - matchingRoom.roomsBlocked || '',
        costStaffOnSite: matchingRoom.staffOnSite || '',
        costRooms: matchingRoom.roomsBooked || '',
        costBlocked: matchingRoom.roomsBlocked || '',
        costPAX: matchingRoom.roomsPAX || ''
        // costOccupancy:
        //   matchingRoom.roomsAvail && matchingRoom.roomsBooked
        //     ? Math.round(
        //       (matchingRoom.roomsBooked / matchingRoom.roomsAvail) * 100
        //     )
        //     : "",
      });
    } else {
    }
  };

  handleCategoryChange = (rowId, value) => {
    this.setState(prevState => ({
      dynamicLabels: {
        ...prevState.dynamicLabels,
        [rowId]: value || 'P/PAX' // ✅ Default value when category is cleared
      }
    }));
  };
  handleCurrencyChange = (rowId, value) => {
    this.setState(prevState => ({
      dynamicLabels: {
        ...prevState.dynamicLabels,
        [rowId]: value || 'Extra Sales' // ✅ Default value when category is cleared
      }
    }));
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { form } = this.props;
    const { selectedYear } = this.state;
    const {
      previewVisible,
      costVisible,
      roomsVisible,
      previewVisibleVariant,
      previewImage,
      fileList,
      previewTitle
    } = this.state;

    const { editStock } = this.props;

    const selectedSite = this.props.sites.find(
      site => site._id === this.props.siteSelected
    );
    const defaultCurrency = selectedSite?.companyCurrency || '';

    return (
      <ResponsiveFormWrap>
        <Form layout="vertical">
          {this.props.previewVisible ? (
            <StyledTabs
              className="edit-form-tabs"
              animated={true}
              style={{
                marginTop: '0em',
                marginLeft: this.props.isMobile ? 0 : '-24px'
              }}
              defaultActiveKey="Sales"
              tabPosition={this.props.isMobile ? 'top' : 'left'}
              type="card"
            >
              <>
                <TabPane tab="Sales Details" key="Sales">
                  <Row>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      {/* <FormItem label="Refund">
                        {form.getFieldDecorator('isRefunded', {
                          rules: [
                            {
                              required: false
                            }
                          ],
                          initialValue: this.state.isRefunded ? true : false
                        })(
                          <Tooltip placement="left" title={form.getFieldValue(
                            'saleRefund'
                          ) == null
                            ? ''
                            : '"Clear Refund value to disable"'
                          }>
                            <Switch
                              // defaultChecked={true}
                              defaultChecked={
                                this.props.editStock &&
                                this.props.editStock.isRefunded
                              }
                              // disabled={true}
                              disabled={hasPrepStepsValue()}
                              onChange={checked =>
                                this.selectisRefunded(checked)
                              }
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                            />
                          </Tooltip>
                        )}
                      </FormItem> */}
                    </Col>
                    {/* <Col span={12} style={{ textAlign: 'right' }}>
                    <FormItem>
                      {form.getFieldDecorator('isActive', {
                        rules: [{ required: false }],
                        initialValue: this.props.editStock
                          ? this.props.editStock.isActive === true
                          : true // Assuming true means 'Active' and false means 'Inactive'
                      })(
                        <Radio.Group buttonStyle="solid">
                          <Radio.Button value={true}>Complimentary / Refund</Radio.Button>
                        </Radio.Group>
                      )}
                    </FormItem>
                  </Col> */}
                    <Col span={5} style={{ display: 'none' }}>
                      <FormItem label={<span>Date</span>}>
                        {form.getFieldDecorator('timeDate', {
                          rules: [{}],
                          initialValue: this.props.editStock
                            ? this.props.editStock.timeDate
                            : this.state.curDT
                        })(
                          <StyledInput
                            variant="filled"
                            value={
                              this.props.editStock
                                ? this.props.editStock.timeDate
                                : this.state.curDT
                            }
                            // defaultValue={this.state.curDT}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={1} />
                  </Row>
                  <Divider orientation="left" orientationmargin={0}>
                    Details
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Capture Your Information Here',
                        children: (
                          <>
                            {/* Date and Category (Only Once at the Top) */}
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1em',
                                marginBottom: '2em'
                              }}
                            >
                              <Col span={4}>
                                <Form.Item label="Date">
                                  {form.getFieldDecorator('saleDate', {
                                    initialValue: this.props.editStock
                                      ? dayjs(this.props.editStock.saleDate)
                                      : undefined
                                  })(
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      placeholder="Sale Date"
                                      size="large"
                                      // disabledDate={current => {
                                      //   const existingDates = this.props.stock
                                      //     .filter(item => item.saleDate)  // Filter out invalid dates
                                      //     .map(item => dayjs(item.saleDate).startOf('day').format("YYYY-MM-DD"))

                                      //   return existingDates.includes(dayjs(current).format("YYYY-MM-DD"));
                                      // }}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item label={`Booking Number `}>
                                  {form.getFieldDecorator(`bookingNr`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.bookingNr
                                      : ''
                                  })(
                                    <Input
                                      size="large"
                                      style={{ width: '100%' }}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item label={`Room Number `}>
                                  {form.getFieldDecorator(`roomNr`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomNr
                                      : ''
                                  })(
                                    <Input
                                      size="large"
                                      style={{ width: '100%' }}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item label={`Cash `}>
                                  {form.getFieldDecorator(`saleCash`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.saleCash
                                      : ''
                                  })(
                                    <InputNumber
                                      size="large"
                                      addonBefore={defaultCurrency || 'R'}
                                      min={0}
                                      step="0.01"
                                    />
                                  )}
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <Form.Item label={`Card `}>
                                  {form.getFieldDecorator(`saleCard`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.saleCard
                                      : ''
                                  })(
                                    <InputNumber
                                      size="large"
                                      addonBefore={defaultCurrency || 'R'}
                                      min={0}
                                      step="0.01"
                                    />
                                  )}
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <Form.Item label={`Bednights `}>
                                  {form.getFieldDecorator(`saleBednights`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.saleBednights
                                      : ''
                                  })(
                                    <InputNumber
                                      size="large"
                                      style={{ width: '100%' }}
                                      min={0}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={9} style={{ display: 'none' }}>
                                {' '}
                                <FormItem label={<span>Assign To</span>}>
                                  {form.getFieldDecorator('access', {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.access
                                      : this.props.siteSelected
                                  })(
                                    <Select
                                      // mode="multiple"
                                      showSearch
                                    >
                                      {/* <Option key="Admin" value="Admin">
                                      Admin
                                    </Option> */}
                                      {this.props.sites.map(site => (
                                        <Option key={site._id} value={site._id}>
                                          {site.name}
                                          {/* {site.name} ({site._id}) */}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col>
                            </Row>

                            {/* Repeating Rows for Cash, Card, Refund, Bednights */}
                            {this.state.salesRows.map(row => {
                              const currencyValue =
                                this.props.form.getFieldValue(
                                  `costCurrency[${row.id}]`
                                ) || row.costCurrency;

                              const site = this.props.sites.find(
                                site => site._id === this.props.siteSelected
                              );
                              const companyCurrency =
                                site?.companyCurrency || '';
                              const currency =
                                site?.exchange?.[currencyValue] || null;
                              return (
                                <Row
                                  className="mobile-line-item"
                                  gutter={12}
                                  key={row.id}
                                  style={{
                                    padding: '2em',
                                    paddingBottom: '1.5em',
                                    paddingTop: '1em',
                                    borderTop: '1px dashed #d9d9d9'
                                  }}
                                >
                                  <Col span={4}>
                                    <Form.Item label="Category">
                                      {form.getFieldDecorator(
                                        `saleCategory[${row.id}]`,
                                        {
                                          initialValue: row.saleCategory
                                        }
                                      )(
                                        <Select
                                          size="large"
                                          allowClear
                                          style={{ width: '100%' }}
                                        >
                                          {[
                                            ...new Set(
                                              this.props.sites.flatMap(
                                                site =>
                                                  site.saleCategories || []
                                              )
                                            )
                                          ].map(category => (
                                            <Option
                                              key={category}
                                              value={category}
                                            >
                                              {category}
                                            </Option>
                                          ))}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={3}>
                                    <Form.Item label="Currency">
                                      {form.getFieldDecorator(
                                        `costCurrency[${row.id}]`,
                                        {
                                          initialValue: this.props.editStock
                                            ? row.costCurrency
                                            : defaultCurrency
                                        }
                                      )(
                                        <Select
                                          size="large"
                                          allowClear
                                          style={{ width: '100%' }}
                                          onChange={value =>
                                            this.handleCurrencyChange(
                                              row.id,
                                              value
                                            )
                                          }
                                        >
                                          {[
                                            ...new Set(
                                              this.props.sites.flatMap(
                                                site =>
                                                  site.availableCurrencies || []
                                              )
                                            )
                                          ].map(currency => (
                                            <Option
                                              key={currency}
                                              value={currency}
                                            >
                                              {currency}
                                            </Option>
                                          ))}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={4}>
                                    <Form.Item label={`Extra Sales`}>
                                      {form.getFieldDecorator(
                                        `extraSalesExchange[${row.id}]`,
                                        {
                                          initialValue: row.extraSalesExchange
                                        }
                                      )(
                                        <InputNumber
                                          size="large"
                                          style={{ width: '100%' }}
                                          step="0.01"
                                          min={0}
                                          formatter={value => {
                                            const currency = form.getFieldValue(
                                              `costCurrency[${row.id}]`
                                            );
                                            return currency
                                              ? `${currency} ${value}`
                                              : value;
                                          }}
                                          parser={value =>
                                            value.replace(/[^\d.]/g, '')
                                          }
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>

                                  <Col span={4}>
                                    <Form.Item
                                      label={`Extra Sales (Exchange) `}
                                    >
                                      {form.getFieldDecorator(
                                        `extraSales[${row.id}]`,
                                        {
                                          initialValue: currency
                                            ? this.props.form.getFieldValue(
                                                `extraSalesExchange[${row.id}]`
                                              ) * currency
                                            : row.extraSales
                                        }
                                      )(
                                        <InputNumber
                                          disabled
                                          size="large"
                                          style={{ width: '100%' }}
                                          step="0.01"
                                          precision={3}
                                          min={0}
                                          formatter={value => {
                                            // strip out formatting then round
                                            const num =
                                              parseFloat(
                                                value
                                                  .toString()
                                                  .replace(/[^\d.-]/g, '')
                                              ) || 0;
                                            const rounded = num.toFixed(3);
                                            return companyCurrency
                                              ? `${companyCurrency} ${rounded}`
                                              : rounded;
                                          }}
                                          parser={value =>
                                            value.replace(/[^\d.]/g, '')
                                          }
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  {/* {currency !== null && (
                                    <Col span={3}>
                                      <Form.Item label="currency">
                                        {form.getFieldDecorator(`currency[${row.id}]`, {
                                          initialValue: currency
                                        })(
                                          <Input
                                            size="large"
                                            readOnly
                                            prefix="R"
                                            style={{ width: "100%", backgroundColor: "#f5f5f5", color: "#000" }}
                                          />
                                        )}
                                      </Form.Item>
                                    </Col>
                                  )} */}

                                  <Col span={4}>
                                    <Form.Item label={`Complimentary / Refund `}>
                                      {form.getFieldDecorator(
                                        `saleRefund[${row.id}]`,
                                        {
                                          initialValue: row.saleRefund
                                        }
                                      )(
                                        <InputNumber
                                          size="large"
                                          style={{ width: '100%' }}
                                          step="0.01"
                                          min={0}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  {/* <Col span={9}>
                                  <Form.Item label={`Comments `}>
                                    {form.getFieldDecorator(`saleComments[${row.id}]`, {
                                      initialValue: row.saleComments,
                                    })(
                                      <Input size="large" style={{ width: '100%' }} />
                                    )}
                                  </Form.Item>
                                </Col> */}
                                  <Col span={3} style={{ marginTop: '2.5em' }}>
                                    {this.state.salesRows.length > 1 &&
                                      row.id ===
                                        this.state.salesRows[
                                          this.state.salesRows.length - 1
                                        ].id && (
                                        <Button
                                          color="danger"
                                          variant="solid"
                                          onClick={() =>
                                            this.handleRemoveRow(row.id)
                                          }
                                        >
                                          Delete
                                        </Button>
                                      )}
                                  </Col>
                                </Row>
                              );
                            })}

                            <Row
                              className="mobile-add-row"
                              style={{
                                paddingLeft: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1em',
                                borderTop: '1px dashed #d9d9d9'
                              }}
                            >
                              <Col span={24}>
                                <Button
                                  icon={
                                    <PlusCircleFilled
                                      style={{
                                        fontSize: '110%',
                                        color: 'white'
                                      }}
                                    />
                                  }
                                  size="large"
                                  onClick={this.handleAddRow}
                                  style={{
                                    width: '10em',
                                    backgroundColor: 'black',
                                    color: 'white'
                                  }}
                                >
                                  Add Row
                                </Button>
                              </Col>
                            </Row>
                          </>
                        )
                      }
                    ]}
                  />
                  {/* <Divider orientation="left" orientationmargin={0}>
                    Proof of Sale
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['3']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '3',
                        label: 'Upload Proof of Sale',
                        children: (
                          <Row
                            gutter={24}
                            style={{ padding: '2em', marginTop: '0em', paddingTop: '0.5em', paddingBottom: '2em', }}
                          >
                            <Col span={8} style={{ padding: '0.5em' }}>
                              <h1
                                style={{
                                  marginBottom: '1em',
                                  fontSize: '15px',
                                  fontWeight: 400
                                  // fontFamily: "Nunito",
                                }}
                              >
                                Proof of Sale Image
                              </h1>
                              <Upload
                                name="mainProductImage"
                                className="avatar-uploader"
                                listType="picture-card"
                                showUploadList={false}
                                beforeUpload={this.beforeUpload}
                                customRequest={this.handleImageUpload}
                                onChange={this.handleMainProductImage}
                                loading={this.state.loading}
                                accept="image/*"
                                disabled={!!this.state.mainProductImage} // Disable if the image exists
                              >
                                {this.state.mainProductImage ? (
                                  <img
                                    style={{
                                      width: '100%',
                                      height: '20em',
                                      objectFit: 'contain'
                                    }}
                                    alt="example"
                                    src={
                                      this.state.mainProductImage.search('data') > -1
                                        ? this.state.mainProductImage
                                        : process.env.REACT_APP_GLOBAL_SERVER +
                                        'sproutmanagement/api/images/' +
                                        this.state.mainProductImage
                                    }
                                  />
                                ) : (
                                  <div style={{ marginTop: 8 }}>
                                    Upload
                                  </div>
                                )}
                              </Upload>
                              <Button
                                size="large"
                                onClick={() => {
                                  this.props.handleDeleteImage(); // Delete image handler
                                  this.setState({ mainProductImage: null }); // Clear image from state
                                }}
                                style={{
                                  background: !this.state.mainProductImage ? "lightgrey" : 'red',
                                  color: 'white',
                                  border: "none",
                                  marginRight: '1em',
                                }}
                                disabled={!this.state.mainProductImage} // Disable delete if no image exists
                              >
                                Delete
                              </Button>
                            </Col>
                          </Row>
                        )
                      }
                    ]}
                  /> */}
                </TabPane>
                {/* {!this.state.isRefunded ||
                this.state.isRefunded === false ? null : (
                <TabPane tab="Complimentary / Refund" key="Refund">
                  <Divider orientation="left" orientationmargin={0}>
                    Create Sale Options
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Create a variety of product options',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                paddingBottom: '1em',
                                display:
                                  !this.state.isRefunded ||
                                    this.state.isRefunded === false
                                    ? 'none'
                                    : ''
                              }}
                            >
                              <Col span={24} style={{ padding: 0 }}>


                              </Col>
                            </Row>{' '}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
              )} */}
              </>
            </StyledTabs>
          ) : this.props.costVisible ? (
            <StyledTabs
              className="edit-form-tabs"
              animated={true}
              style={{
                marginTop: '0em',
                marginLeft: this.props.isMobile ? 0 : '-24px'
              }}
              defaultActiveKey="Cost"
              tabPosition={this.props.isMobile ? 'top' : 'left'}
              type="card"
            >
              <>
                <TabPane tab="Cost Details" key="Cost">
                  <Row>
                    <Col span={5} style={{ display: 'none' }}>
                      <FormItem label={<span>Date</span>}>
                        {form.getFieldDecorator('timeDate', {
                          rules: [{}],
                          initialValue: this.props.editStock
                            ? this.props.editStock.timeDate
                            : this.state.curDT
                        })(
                          <StyledInput
                            variant="filled"
                            value={
                              this.props.editStock
                                ? this.props.editStock.timeDate
                                : this.state.curDT
                            }
                            // defaultValue={this.state.curDT}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={1} />
                  </Row>
                  <Divider orientation="left" orientationmargin={0}>
                    Details
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Capture Your Information Here',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1em'
                              }}
                            >
                              <Col span={5}>
                                <FormItem label="Date">
                                  {form.getFieldDecorator('costDate', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? dayjs(this.props.editStock.costDate)
                                      : undefined
                                  })(
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costDate'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Cost Date"
                                      onChange={this.handleDateChange} // Trigger date change logic
                                      disabledDate={current => {
                                        const existingDates = this.props.stock
                                          .filter(item => item.costDate) // Filter out invalid dates
                                          .map(item =>
                                            dayjs(item.costDate)
                                              .startOf('day')
                                              .format('YYYY-MM-DD')
                                          );

                                        return existingDates.includes(
                                          dayjs(current).format('YYYY-MM-DD')
                                        );
                                      }}
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              {/* <Col span={5} style={{ marginBottom: '1em' }}>
                                <FormItem label="Category">
                                  {form.getFieldDecorator(
                                    'costCategory',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Sale Title required'
                                        }
                                      ],
                                      initialValue: this.props.editStock
                                        ? this.props.editStock.costCategory
                                        : []
                                    }
                                  )(
                                    <Select
                                      size="large"
                                      allowClear
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costCategory'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                    >
                                      {[...new Set(this.props.sites.flatMap(site => site.costCategories || []))].map(category => (
                                        <Option key={category} value={category}>
                                          {category}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col> */}
                              {/* <Col span={4}>
                                <Form.Item label={`Daily Budget `}>
                                  {form.getFieldDecorator(`costBudget`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costBudget
                                      : "",
                                  })(
                                    <InputNumber variant={
                                      this.props.form.getFieldValue("costBudget") == null
                                        ? "outlined"
                                        : "filled"
                                    } size="large" style={{ width: '100%' }} step="0.01" min={0} />
                                  )}
                                </Form.Item>
                              </Col> */}
                              <Col span={4}>
                                <FormItem label="Staff On Site">
                                  {form.getFieldDecorator('costStaffOnSite', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Staff On Site required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costStaffOnSite
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costStaffOnSite'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Staff On Site"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1.5em',
                                marginBottom: '1.5em'
                              }}
                            >
                              <Col span={5}>
                                <FormItem label="Rooms Available">
                                  {form.getFieldDecorator('costRoomsAvail', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costRoomsAvail
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costRoomsAvail'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Available"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={5}>
                                <FormItem label="Rooms Booked">
                                  {form.getFieldDecorator('costRooms', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costRooms
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costRooms'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Booked"
                                    />
                                  )}
                                </FormItem>
                              </Col>

                              <Col span={5}>
                                <FormItem label="Occupancy %">
                                  {form.getFieldDecorator('costOccupancy', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue:
                                      this.props.form.getFieldValue(
                                        'costRooms'
                                      ) &&
                                      this.props.form.getFieldValue(
                                        'costRoomsAvail'
                                      )
                                        ? Math.round(
                                            (this.props.form.getFieldValue(
                                              'costRooms'
                                            ) /
                                              this.props.form.getFieldValue(
                                                'costRoomsAvail'
                                              )) *
                                              100
                                          ) // Ensure the value is a number
                                        : undefined,
                                    getValueFromEvent: value =>
                                      typeof value === 'string'
                                        ? Number(value)
                                        : value // Convert string to number
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costOccupancy'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Occupancy %"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={5}>
                                <FormItem label="PAX">
                                  {form.getFieldDecorator('costPAX', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costPAX
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costPAX'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="PAX"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={9} style={{ display: 'none' }}>
                                {' '}
                                <FormItem label={<span>Assign To</span>}>
                                  {form.getFieldDecorator('access', {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.access
                                      : this.props.siteSelected
                                  })(
                                    <Select
                                      // mode="multiple"
                                      showSearch
                                    >
                                      {/* <Option key="Admin" value="Admin">
                                      Admin
                                    </Option> */}
                                      {this.props.sites.map(site => (
                                        <Option key={site._id} value={site._id}>
                                          {site.name}
                                          {/* {site.name} ({site._id}) */}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                            {this.state.costRows.map(row => {
                              const categoryValue =
                                this.props.form.getFieldValue(
                                  `costCategory[${row.id}]`
                                ) || row.costCategory;
                              const labelText =
                                categoryValue === 'Staff Food'
                                  ? 'P/Staff'
                                  : 'P/PAX';
                              const peopleCountField =
                                categoryValue === 'Staff Food'
                                  ? 'costStaffOnSite'
                                  : 'costPAX';
                              const site = this.props.sites.find(
                                site => site._id === this.props.siteSelected
                              );
                              const dailyBudget =
                                site?.dailyBudgets?.[categoryValue] ?? null;

                              // pull the current costPrice value from the form (fall back to row.costPrice if untouched)
                              const costField = `costPrice[${row.id}]`;
                              const costValue =
                                this.props.form.getFieldValue(costField) ??
                                row.costPrice;
                              const overBudget =
                                dailyBudget !== null && costValue > dailyBudget;
                              const companyCurrency =
                                this.props.sites.find(
                                  site => site._id === this.props.siteSelected
                                )?.companyCurrency || 'R';
                              return (
                                <Row
                                  className="mobile-line-item"
                                  gutter={12}
                                  key={row.id}
                                  style={{
                                    padding: '1.5em 2em 1em',
                                    borderTop: '1px dashed #d9d9d9'
                                  }}
                                >
                                  <Col span={4}>
                                    <Form.Item label="Category">
                                      {form.getFieldDecorator(
                                        `costCategory[${row.id}]`,
                                        {
                                          initialValue: row.costCategory
                                        }
                                      )(
                                        <Select
                                          size="large"
                                          allowClear
                                          style={{ width: '100%' }}
                                          onChange={value =>
                                            this.handleCategoryChange(
                                              row.id,
                                              value
                                            )
                                          }
                                        >
                                          {[
                                            ...new Set(
                                              this.props.sites.flatMap(
                                                s => s.costCategories || []
                                              )
                                            )
                                          ].map(cat => (
                                            <Option key={cat} value={cat}>
                                              {cat}
                                            </Option>
                                          ))}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>

                                  <Col span={4}>
                                    <Form.Item label="Cost">
                                      {form.getFieldDecorator(costField, {
                                        initialValue: row.costPrice
                                      })(
                                        <InputNumber
                                          size="large"
                                          style={{
                                            width: '100%',
                                            backgroundColor: overBudget
                                              ? 'rgba(255, 0, 0, 0.37)'
                                              : undefined // ← turns red when cost > budget
                                          }}
                                          addonBefore={defaultCurrency || 'R'}
                                          min={0}
                                          step="0.01"
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>

                                  <Col span={3}>
                                    <Form.Item label={labelText}>
                                      {form.getFieldDecorator(
                                        `costPerPerson[${row.id}]`,
                                        {
                                          initialValue:
                                            costValue &&
                                            this.props.form.getFieldValue(
                                              peopleCountField
                                            )
                                              ? Math.round(
                                                  (costValue /
                                                    this.props.form.getFieldValue(
                                                      peopleCountField
                                                    )) *
                                                    100
                                                ) / 100
                                              : undefined
                                        }
                                      )(
                                        <InputNumber
                                          size="large"
                                          style={{ width: '100%' }}
                                          step={0.01}
                                          min={0}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>

                                  {dailyBudget !== null && (
                                    <Col span={4}>
                                      <Form.Item label="Daily Budget">
                                        {form.getFieldDecorator(
                                          `dailyBudget[${row.id}]`,
                                          {
                                            // keep this as a Number, not a formatted string
                                            initialValue:
                                              dailyBudget != null
                                                ? Number(dailyBudget)
                                                : undefined
                                          }
                                        )(
                                          <InputNumber
                                            size="large"
                                            style={{ width: '100%' }}
                                            min={0}
                                            step={0.01}
                                            // display with commas and two decimals, plus a currency prefix
                                            formatter={value => {
                                              if (value == null) return '';
                                              // insert commas every 3 digits, fix two decimals
                                              const [
                                                intPart,
                                                decPart = ''
                                              ] = value.toString().split('.');
                                              const withCommas = intPart.replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ','
                                              );
                                              const paddedDec = (
                                                decPart + '00'
                                              ).slice(0, 2);
                                              return `${companyCurrency} ${withCommas}.${paddedDec}`;
                                            }}
                                            // strip out anything that isn’t a digit or dot
                                            parser={value =>
                                              value.replace(/[^\d.]/g, '')
                                            }
                                          />
                                        )}
                                      </Form.Item>
                                    </Col>
                                  )}
                                  <Col span={6}>
                                    <Form.Item label={`Comments `}>
                                      {form.getFieldDecorator(
                                        `costComments[${row.id}]`,
                                        {
                                          initialValue: row.costComments
                                        }
                                      )(
                                        <Input
                                          size="large"
                                          style={{ width: '100%' }}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={3} style={{ marginTop: '2.5em' }}>
                                    {this.state.costRows.length > 1 &&
                                      row.id ===
                                        this.state.costRows[
                                          this.state.costRows.length - 1
                                        ].id && (
                                        <Button
                                          color="danger"
                                          variant="solid"
                                          onClick={() =>
                                            this.handleRemoveRowCost(row.id)
                                          }
                                        >
                                          Delete
                                        </Button>
                                      )}
                                  </Col>
                                </Row>
                              );
                            })}

                            <Row
                              className="mobile-add-row"
                              style={{
                                paddingLeft: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1em',
                                borderTop: '1px dashed #d9d9d9'
                              }}
                            >
                              <Col span={24}>
                                <Button
                                  icon={
                                    <PlusCircleFilled
                                      style={{
                                        fontSize: '110%',
                                        color: 'white'
                                      }}
                                    />
                                  }
                                  size="large"
                                  onClick={this.handleAddRowCost}
                                  style={{
                                    width: '10em',
                                    backgroundColor: 'black',
                                    color: 'white'
                                  }}
                                >
                                  Add Row
                                </Button>
                              </Col>
                            </Row>

                            {/* <Row
                              gutter={24}
                              style={{ padding: '2em', paddingBottom: '2em', paddingTop: '1em', borderTop: "1px dashed #d9d9d9", }}
                            >
                              <Col span={24} style={{ marginTop: '1em', paddingBottom: "2em" }}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Remarks/ Comments"
                                >
                                  {form.getFieldDecorator(
                                    'costNote',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Category required'
                                        }
                                      ],
                                      initialValue: this.props.editStock
                                        ? this.props.editStock.costNote
                                        : ""
                                    }
                                  )(
                                    <TextArea
                                      style={{ width: "100%" }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costNote'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Enter Comments"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                            </Row> */}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
                {/* {!this.state.isRefunded ||
                this.state.isRefunded === false ? null : (
                <TabPane tab="Complimentary / Refund" key="Refund">
                  <Divider orientation="left" orientationmargin={0}>
                    Create Sale Options
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Create a variety of product options',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                paddingBottom: '1em',
                                display:
                                  !this.state.isRefunded ||
                                    this.state.isRefunded === false
                                    ? 'none'
                                    : ''
                              }}
                            >
                              <Col span={24} style={{ padding: 0 }}>


                              </Col>
                            </Row>{' '}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
              )} */}
              </>
            </StyledTabs>
          ) : this.props.roomsVisible ? (
            <StyledTabs
              className="edit-form-tabs"
              animated={true}
              style={{
                marginTop: '0em',
                marginLeft: this.props.isMobile ? 0 : '-24px'
              }}
              defaultActiveKey="Rooms"
              tabPosition={this.props.isMobile ? 'top' : 'left'}
              type="card"
            >
              <>
                <TabPane tab="Rooms Details" key="Rooms">
                  <Row>
                    <Col span={5} style={{ display: 'none' }}>
                      <FormItem label={<span>Date</span>}>
                        {form.getFieldDecorator('timeDate', {
                          rules: [{}],
                          initialValue: this.props.editStock
                            ? this.props.editStock.timeDate
                            : this.state.curDT
                        })(
                          <StyledInput
                            variant="filled"
                            value={
                              this.props.editStock
                                ? this.props.editStock.timeDate
                                : this.state.curDT
                            }
                            // defaultValue={this.state.curDT}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={1} />
                  </Row>
                  <Divider orientation="left" orientationmargin={0}>
                    Details
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Capture Your Information Here',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1em'
                              }}
                            >
                              <Col span={5}>
                                <FormItem label="Date">
                                  {form.getFieldDecorator('roomsDate', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ?.roomsDate
                                      ? dayjs(this.props.editStock.roomsDate)
                                      : undefined
                                  })(
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsDate'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Select Date"
                                      disabledDate={current => {
                                        const existingDates = this.props.stock
                                          .filter(item => item.roomsDate)
                                          .map(item =>
                                            dayjs(item.roomsDate)
                                              .startOf('day')
                                              .format('YYYY-MM-DD')
                                          );

                                        return existingDates.includes(
                                          dayjs(current).format('YYYY-MM-DD')
                                        );
                                      }}
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={5}>
                                <FormItem label="Staff On Site">
                                  {form.getFieldDecorator('staffOnSite', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Staff On Site required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.staffOnSite
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'staffOnSite'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Staff On Site"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col
                                span={5}
                                style={{ marginBottom: '1em', display: 'none' }}
                              >
                                <FormItem label="Category">
                                  {form.getFieldDecorator('roomsCategory', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Sale Title required'
                                      }
                                    ],
                                    initialValue: 'Rooms'
                                  })(
                                    <StyledInput
                                      size="large"
                                      allowClear
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsCategory'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              {/* <Col span={5} style={{ marginBottom: '1em' }}>
                                <FormItem label="Category">
                                  {form.getFieldDecorator(
                                    'costCategory',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Sale Title required'
                                        }
                                      ],
                                      initialValue: this.props.editStock
                                        ? this.props.editStock.costCategory
                                        : []
                                    }
                                  )(
                                    <Select
                                      size="large"
                                      allowClear
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costCategory'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                    >
                                      <Option key="Room" value="Room">
                                        Room
                                      </Option>
                                      <Option key="Bar" value="Bar">
                                        Bar
                                      </Option>
                                      <Option key="Housekeeping" value="Housekeeping">
                                        Housekeeping
                                      </Option>
                                      <Option key="Gas" value="Gas">
                                        Gas
                                      </Option>
                                      <Option key="Kerosene" value="Kerosene">
                                        Kerosene
                                      </Option>
                                      <Option key="Drivers" value="Drivers">
                                        Drivers
                                      </Option>
                                    </Select>
                                  )}
                                </FormItem>
                              </Col> */}
                            </Row>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1.5em',
                                borderTop: '1px dashed #d9d9d9',
                                marginTop: '2em'
                              }}
                            >
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Rooms Available"
                                >
                                  {form.getFieldDecorator('roomsAvail', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsAvail
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsAvail'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Available"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Rooms Booked"
                                >
                                  {form.getFieldDecorator('roomsBooked', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsBooked
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsBooked'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Booked"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Blocked Rooms"
                                >
                                  {form.getFieldDecorator('roomsBlocked', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsBlocked
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsBlocked'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Blocked Rooms"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem label="Guide Meals">
                                  {form.getFieldDecorator('guideMeals', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Guide meals required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.guideMeals
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      min={0}
                                      precision={0}
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'guideMeals'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Guide Meals"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1.5em',
                                borderTop: '1px dashed #d9d9d9'
                              }}
                            >
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="PAX"
                                >
                                  {form.getFieldDecorator('roomsPAX', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsPAX
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomPAX'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Enter PAX"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem label="Occupancy %">
                                  {form.getFieldDecorator('roomOccupancy', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue:
                                      this.props.form.getFieldValue(
                                        'roomsBooked'
                                      ) &&
                                      this.props.form.getFieldValue(
                                        'roomsAvail'
                                      )
                                        ? Math.round(
                                            (this.props.form.getFieldValue(
                                              'roomsBooked'
                                            ) /
                                              (this.props.form.getFieldValue(
                                                'roomsAvail'
                                              ) -
                                                (this.props.form.getFieldValue(
                                                  'roomsBlocked'
                                                ) || 0))) *
                                              100
                                          )
                                        : undefined,
                                    getValueFromEvent: value =>
                                      typeof value === 'string'
                                        ? Number(value)
                                        : value // Convert string to number
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomOccupancy'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Occupancy %"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4} />
                              <Col span={9} style={{ display: 'none' }}>
                                {' '}
                                <FormItem label={<span>Assign To</span>}>
                                  {form.getFieldDecorator('access', {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.access
                                      : this.props.siteSelected
                                  })(
                                    <Select
                                      // mode="multiple"
                                      showSearch
                                    >
                                      {/* <Option key="Admin" value="Admin">
                                      Admin
                                    </Option> */}
                                      {this.props.sites.map(site => (
                                        <Option key={site._id} value={site._id}>
                                          {site.name}
                                          {/* {site.name} ({site._id}) */}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
                {/* {!this.state.isRefunded ||
                this.state.isRefunded === false ? null : (
                <TabPane tab="Complimentary / Refund" key="Refund">
                  <Divider orientation="left" orientationmargin={0}>
                    Create Sale Options
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Create a variety of product options',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                paddingBottom: '1em',
                                display:
                                  !this.state.isRefunded ||
                                    this.state.isRefunded === false
                                    ? 'none'
                                    : ''
                              }}
                            >
                              <Col span={24} style={{ padding: 0 }}>


                              </Col>
                            </Row>{' '}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
              )} */}
              </>
            </StyledTabs>
          ) : this.props.compVisible ? (
            <StyledTabs
              className="edit-form-tabs"
              animated={true}
              style={{
                marginTop: '0em',
                marginLeft: this.props.isMobile ? 0 : '-24px'
              }}
              defaultActiveKey="Complimentary"
              tabPosition={this.props.isMobile ? 'top' : 'left'}
              type="card"
            >
              <>
                <TabPane tab="Room Inclusion Details" key="Complimentary">
                  <Divider orientation="left" orientationmargin={0}>
                    Details
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Capture Your Information Here',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1em'
                              }}
                            >
                              <Col span={5}>
                                <FormItem label="Date">
                                  {form.getFieldDecorator('compDate', {
                                    rules: [
                                      {
                                        required: true,
                                        message: 'Date is required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? dayjs(this.props.editStock.compDate)
                                      : undefined
                                  })(
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'compDate'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Room Inclusion Date"
                                      disabledDate={current => {
                                        // One complimentary record per day, same
                                        // rule the other tabs use for their date.
                                        const existingDates = this.props.stock
                                          .filter(
                                            item =>
                                              item.compDate &&
                                              (!this.props.editStock ||
                                                item._id !==
                                                  this.props.editStock._id)
                                          )
                                          .map(item =>
                                            dayjs(item.compDate)
                                              .startOf('day')
                                              .format('YYYY-MM-DD')
                                          );

                                        return existingDates.includes(
                                          dayjs(current).format('YYYY-MM-DD')
                                        );
                                      }}
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={9} style={{ display: 'none' }}>
                                <FormItem label={<span>Assign To</span>}>
                                  {form.getFieldDecorator('access', {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.access
                                      : this.props.siteSelected
                                  })(
                                    <Select showSearch>
                                      {this.props.sites.map(site => (
                                        <Option key={site._id} value={site._id}>
                                          {site.name}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col>
                            </Row>

                            {this.state.compRows.map(row => (
                              <Row
                                className="mobile-line-item"
                                gutter={12}
                                key={row.id}
                                style={{
                                  padding: '1.5em 2em 1em',
                                  borderTop: '1px dashed #d9d9d9'
                                }}
                              >
                                <Col span={4}>
                                  <Form.Item label="Category">
                                    {form.getFieldDecorator(
                                      `compCategory[${row.id}]`,
                                      {
                                        initialValue: row.compCategory
                                      }
                                    )(
                                      <Select
                                        size="large"
                                        allowClear
                                        style={{ width: '100%' }}
                                      >
                                        {(() => {
                                          // Site-configurable if compCategories
                                          // is ever added; sensible defaults now.
                                          const configured = [
                                            ...new Set(
                                              this.props.sites.flatMap(
                                                s => s.compCategories || []
                                              )
                                            )
                                          ];
                                          const categories = configured.length
                                            ? configured
                                            : [
                                                'Spa',
                                                'Meal',
                                                'Drinks',
                                                'Activity',
                                                'Other'
                                              ];
                                          return categories.map(cat => (
                                            <Option key={cat} value={cat}>
                                              {cat}
                                            </Option>
                                          ));
                                        })()}
                                      </Select>
                                    )}
                                  </Form.Item>
                                </Col>

                                <Col span={5}>
                                  <Form.Item label="Description">
                                    {form.getFieldDecorator(
                                      `compDescription[${row.id}]`,
                                      {
                                        initialValue: row.compDescription
                                      }
                                    )(
                                      <Input
                                        size="large"
                                        style={{ width: '100%' }}
                                        placeholder="e.g. 60min massage"
                                      />
                                    )}
                                  </Form.Item>
                                </Col>

                                <Col span={4}>
                                  <Form.Item label="Value">
                                    {form.getFieldDecorator(
                                      `compValue[${row.id}]`,
                                      {
                                        initialValue: row.compValue
                                      }
                                    )(
                                      <InputNumber
                                        size="large"
                                        style={{ width: '100%' }}
                                        addonBefore={defaultCurrency || 'R'}
                                        min={0}
                                        step="0.01"
                                      />
                                    )}
                                  </Form.Item>
                                </Col>

                                <Col span={4}>
                                  <Form.Item label="Guest / Room">
                                    {form.getFieldDecorator(
                                      `compGuest[${row.id}]`,
                                      {
                                        initialValue: row.compGuest
                                      }
                                    )(
                                      <Input
                                        size="large"
                                        style={{ width: '100%' }}
                                      />
                                    )}
                                  </Form.Item>
                                </Col>

                                <Col span={4}>
                                  <Form.Item label="Booking Number">
                                    {form.getFieldDecorator(
                                      `compBookingNr[${row.id}]`,
                                      {
                                        initialValue: row.compBookingNr
                                      }
                                    )(
                                      <Input
                                        size="large"
                                        style={{ width: '100%' }}
                                      />
                                    )}
                                  </Form.Item>
                                </Col>

                                <Col span={3} style={{ marginTop: '2.5em' }}>
                                  {this.state.compRows.length > 1 &&
                                    row.id ===
                                      this.state.compRows[
                                        this.state.compRows.length - 1
                                      ].id && (
                                      <Button
                                        color="danger"
                                        variant="solid"
                                        onClick={() =>
                                          this.handleRemoveRowComp(row.id)
                                        }
                                      >
                                        Delete
                                      </Button>
                                    )}
                                </Col>

                                <Col span={20}>
                                  <Form.Item label="Comments">
                                    {form.getFieldDecorator(
                                      `compComments[${row.id}]`,
                                      {
                                        initialValue: row.compComments
                                      }
                                    )(
                                      <Input
                                        size="large"
                                        style={{ width: '100%' }}
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                              </Row>
                            ))}

                            <Row
                              className="mobile-add-row"
                              style={{
                                paddingLeft: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1em',
                                borderTop: '1px dashed #d9d9d9'
                              }}
                            >
                              <Col span={24}>
                                <Button
                                  icon={
                                    <PlusCircleFilled
                                      style={{
                                        fontSize: '110%',
                                        color: 'white'
                                      }}
                                    />
                                  }
                                  size="large"
                                  onClick={this.handleAddRowComp}
                                  style={{
                                    width: '10em',
                                    backgroundColor: 'black',
                                    color: 'white'
                                  }}
                                >
                                  Add Row
                                </Button>
                              </Col>
                            </Row>
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
              </>
            </StyledTabs>
          ) : null}
          <Modal
            visible={previewVisible}
            title={previewTitle}
            footer={null}
            onCancel={this.handleCancel}
          >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
          </Modal>{' '}
        </Form>
      </ResponsiveFormWrap>
    );
  }
}
const StockForm = Form.create()(AddStockForm);

class Stock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inventoryCostSiteId: null, // mapped inventory site id from the selected normal site
      inventorySites: [], // optional: store inventory sites if you want names/currency
      stockRequests: [], // the request rows from findAllStockRequestsclient
      totalStockRequests: 0,
      selectedCurrency: null, // Store the selected category
      selectedCategory: null, // Store the selected category
      selectedCategoryCost: null, // Store the selected category
      selectedCategoryRooms: null, // Store the selected category
      open: false,
      loading: false,
      closed: false,
      rejectReason: '',
      editStock: undefined,
      size: 'large',
      flag: false,
      currentTab: 'All',
      openSteps: false,
      searchText: '',
      expandedRowKeys: [],
      duplicateModal: false,
      dataSource: this.props.stock,
      siteSelected: resolveSelectedSite(
        this.props.selectedSite,
        this.props.sites
      ),
      stockData: [],
      totalStock: 0,
      currentPage: 1,
      selectedYear: dayjs().format('YYYY'),
      selectedMonths: [dayjs().format('MM')], // default to current month
      activeTabKey: 'Variable Rooms',
      compVisible: false,
      selectedCompCategory: undefined,
      pageSize: 1000, // or any default page size you prefer
      filteredRooms: [],
      steps: [
        {
          title: 'Add a Sale',
          description: 'Click Here to add a new awesome product!',
          placement: 'right',
          target: () => this.ref.current
        }
      ]
    };
    this.ref = React.createRef();
  }
  handleSearchProduct = value => {
    this.setState({ searchText: value });
  };

  componentDidMount = value => {
    this.setState({ loading: true, selectedYear: dayjs().format('YYYY') });

    Promise.all([
      this.fetchAllStock(),
      this.fetchAllSites(),
      this.fetchAllSitesInventory(), // ✅ add
      this.fetchAllUsers()
    ])
      .then(() => {
        // after sites are loaded, map siteSelected -> inventorySiteId
        const selectedSite = (this.props.sites || []).find(
          s => String(s._id) === String(this.state.siteSelected)
        );

        const inventoryCostSiteId = selectedSite?.inventorySiteId
          ? String(selectedSite.inventorySiteId)
          : null;

        this.setState({ inventoryCostSiteId }, async () => {
          // ✅ only fetch requests if a linked inventory site exists
          if (inventoryCostSiteId) {
            await this.fetchAllStockRequests(1, 10000);
          }
        });

        this.setState({ loading: false });
      })
      .catch(error => {
        console.error('Error during componentDidMount:', error);
        this.setState({ loading: false });
        Notify('error', 'Error', error.message || 'An error occurred');
      });

    window.addEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  }

  fetchAllSitesInventory = async () => {
    const res = await this.props.findAllSitesInventory();
    // depending on your action, res.data might be { allSites: [...] }
    const inv =
      res?.data?.allSites || res?.data?.inventorySites || res?.data || [];
    this.setState({ inventorySites: inv });
    return inv;
  };

  fetchAllStockRequests = async (page = 1, pageSize = 10000) => {
    const { inventoryCostSiteId, selectedYear, selectedMonths } = this.state;
    if (!inventoryCostSiteId) return;

    // use first selected month for now (your Stock.js uses selectedMonths array)
    const month =
      Array.isArray(selectedMonths) && selectedMonths.length > 0
        ? selectedMonths[0]
        : dayjs().format('MM');

    const startDate = dayjs(`${selectedYear}-${month}-01`).format('YYYY-MM-DD');
    const endDate = dayjs(`${selectedYear}-${month}-01`)
      .endOf('month')
      .format('YYYY-MM-DD');

    const response = await this.props.findAllStockRequests(
      String(inventoryCostSiteId), // searchQuery = access/site id
      startDate,
      endDate,
      page,
      pageSize
    );

    const { stock, total } = response?.data || {};
    this.setState({
      stockRequests: stock || [],
      totalStockRequests: total || 0
    });
  };

  fetchAllStock = async (page = 1, pageSize = 1000) => {
    try {
      this.setState({ loading: true });

      const response = await this.props.findAllStock(
        this.state.siteSelected,
        this.state.currentPage,
        this.state.pageSize,
        '', // optional searchQuery
        this.state.selectedYear,
        this.state.selectedMonths // ✅ now passing months
      );

      const { stock, total } = response.data;

      this.setState({
        stockData: stock,
        totalStock: total,
        stock,
        totalItems: total,
        currentPage: page,
        pageSize,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      Notify('error', error.message);
    }
  };

  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };

  fetchAllUsers = () => {
    return this.props.findAllUsers().catch(error => {
      throw new Error(`Error fetching users: ${error}`);
    });
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  stockForm;
  onAddStock = e => {
    this.setState({ previewVisible: true, editStock: undefined });
  };

  onAddStockCost = e => {
    this.setState({ costVisible: true, editStock: undefined });
  };

  onAddStockRooms = e => {
    this.setState({ roomsVisible: true, editStock: undefined });
  };

  onAddStockComp = e => {
    this.setState({ compVisible: true, editStock: undefined });
  };

  closeStockForm = () => {
    this.setState({
      siteSelected: this.state.siteSelected,
      previewVisibleVariant: false,
      previewVisible: false,
      costVisible: false,
      roomsVisible: false,
      compVisible: false,
      editStock: undefined
    });
  };

  handleStockTabChange = activeTabKey => {
    this.setState({ activeTabKey });
    localStorage.setItem('activeTabKey', activeTabKey);
  };

  handleDeleteImage = () => {
    const imageField = 'mainProductImage';
    const imageId = this.state.editStock?.[imageField]; // Get the image name

    if (!imageId) {
      Notify('error', 'No image available to delete');
      return;
    }

    this.props
      .deleteStockImage(imageId, imageField)
      .then(() => {
        this.setState({ [imageField]: null }); // Clear the image from the state
        Notify('success', 'Image deleted successfully');
      })
      .catch(error => {
        Notify('error', `Error deleting image: ${error.message}`);
      });
  };
  handleDeleteImage2 = () => {
    const imageField = 'mainProductImageAlt1';
    const imageId = this.state.editStock?.[imageField]; // Get the image name

    if (!imageId) {
      Notify('error', 'No image available to delete');
      return;
    }

    this.props
      .deleteStockImage(imageId, imageField)
      .then(() => {
        this.setState({ [imageField]: null }); // Clear the image from the state
        Notify('success', 'Image deleted successfully');
      })
      .catch(error => {
        Notify('error', `Error deleting image: ${error.message}`);
      });
  };
  handleAddStock = async e => {
    e.preventDefault();

    this.stockForm.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({ loading: true });

        // 👇 Format costDate before submitting
        const formattedValues = {
          ...values,
          costDate: values.costDate
            ? dayjs(values.costDate).format('YYYY-MM-DD')
            : null,
          saleDate: values.saleDate
            ? dayjs(values.saleDate).format('YYYY-MM-DD')
            : null,
          roomsDate: values.roomsDate
            ? dayjs(values.roomsDate).format('YYYY-MM-DD')
            : null,
          compDate: values.compDate
            ? dayjs(values.compDate).format('YYYY-MM-DD')
            : null
        };
        if (this.state.editStock) {
          formattedValues._id = this.state.editStock._id;
        }

        try {
          await this.props.addStock(formattedValues); // 👈 use formatted values

          // Fetch updated stock data
          const response = await this.props.findAllStock(
            this.state.siteSelected,
            this.state.currentPage,
            this.state.pageSize,
            '', // optional searchQuery
            this.state.selectedYear,
            this.state.selectedMonths
          );

          const { stock, total } = response.data;

          this.setState({
            stockData: stock,
            totalStock: total,
            totalItems: total,
            loading: false,
            addStockVisible: false,
            editStock: undefined,
            previewVisible: false,
            costVisible: false,
            roomsVisible: false,
            compVisible: false,
            previewVisibleVariant: false,
            currentTab: 'All'
          });

          Notify('success', 'Successfully added');
        } catch (error) {
          console.error('Error while adding stock:', error);
          Notify('error', error.message || 'An error occurred.');
        } finally {
          this.setState({ loading: false });
        }
      } else {
        console.error('Validation failed:', err);
      }
    });
  };

  handleEditStock = e => {
    this.setState({ previewVisible: true, editStock: e });
  };
  handleEditStockCost = e => {
    this.setState({ costVisible: true, editStock: e });
  };
  handleEditStockRooms = e => {
    this.setState({ roomsVisible: true, editStock: e });
  };
  handleEditStockComp = e => {
    this.setState({ compVisible: true, editStock: e });
  };
  handleDeleteStock = async e => {
    this.setState({ loading: true, deleteVisible: false });

    try {
      // Destructure necessary state values
      const { deleteStock, siteSelected, currentPage, pageSize } = this.state;

      // Delete the selected stock item
      await this.props.deleteStock(deleteStock._id);

      // Fetch the updated list of ingredients after deletion
      const response = await this.props.findAllStock(
        this.state.siteSelected,
        this.state.currentPage,
        this.state.pageSize,
        '', // optional searchQuery
        this.state.selectedYear,
        this.state.selectedMonths // ✅ now passing months
      );

      // Check if response is valid and contains data
      const stock = response?.data?.stock || []; // Default to an empty array if no data
      const total = response?.data?.total || 0; // Default to 0 if no total

      // Update the state with the fetched ingredients or empty state
      this.setState({
        stockData: stock,
        totalStock: total,
        totalItems: total,
        loading: false,
        addStockVisible: false,
        editStock: undefined,
        previewVisible: false,
        costVisible: false,
        roomsVisible: false,
        compVisible: false,
        previewVisibleVariant: false,
        currentTab: 'All'
      });

      // Notify success with fallback for empty state
      if (stock.length === 0) {
        Notify('info', 'No data found', 'The database is currently empty.');
      } else {
        Notify('success', 'Deleted item', 'Successfully deleted item.');
      }
    } catch (e) {
      // Handle errors gracefully
      this.setState({ loading: false });
      Notify(
        'error',
        'Error deleting item',
        e.message || 'An unexpected error occurred.'
      );
    }
  };

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter
    });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#80CE90' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  handleSearchName = async () => {
    if (this.state.siteSelected.length > 0) {
      this.setState({ loading: true });

      try {
        // ✅ 1) Map selected normal site -> linked inventory site (for costs)
        const selectedSite = (this.props.sites || []).find(
          s => String(s._id) === String(this.state.siteSelected)
        );

        const inventoryCostSiteId = selectedSite?.inventorySiteId
          ? String(selectedSite.inventorySiteId)
          : null;

        // store it so Variable Cost tab can use it
        this.setState({ inventoryCostSiteId });

        // ✅ 2) Fetch normal stock (your existing logic) - already supports selectedMonths
        const response = await this.props.findAllStock(
          this.state.siteSelected,
          this.state.currentPage,
          this.state.pageSize,
          '', // optional searchQuery
          this.state.selectedYear,
          this.state.selectedMonths
        );

        const { stock, total } = response.data;

        this.setState({
          stockData: stock || [],
          totalStock: total || 0,
          currentPage: 1
        });

        // ✅ 3) Fetch requests for ALL selected months (merge + dedupe)
        if (inventoryCostSiteId) {
          const months =
            Array.isArray(this.state.selectedMonths) &&
            this.state.selectedMonths.length > 0
              ? this.state.selectedMonths.map(String)
              : [];

          const rows = (this.state.stockRequests || []).filter(r => {
            if (!r.requestDate) return false;
            const mm = dayjs(r.requestDate).format('MM');
            return months.includes(mm);
          });

          const results = await Promise.all(
            months.map(m => {
              const startDate = dayjs(
                `${this.state.selectedYear}-${m}-01`
              ).format('YYYY-MM-DD');
              const endDate = dayjs(`${this.state.selectedYear}-${m}-01`)
                .endOf('month')
                .format('YYYY-MM-DD');

              return this.props.findAllStockRequests(
                inventoryCostSiteId, // access/searchQuery
                startDate,
                endDate,
                1,
                10000
              );
            })
          );

          const allRows = results.flatMap(r => r?.data?.stock || []);
          const deduped = Array.from(
            new Map(allRows.map(x => [String(x._id), x])).values()
          );

          this.setState({
            stockRequests: deduped,
            totalStockRequests: deduped.length
          });
        } else {
          // no mapping => clear requests so you fall back to old cost logic
          this.setState({
            stockRequests: [],
            totalStockRequests: 0
          });
        }

        this.setState({ loading: false });
      } catch (e) {
        this.setState({ loading: false });
        Notify('error', e.message || 'Error loading data');
      }
    }
  };
  accessMatches = (itemAccess, siteId) => {
    if (!siteId) return true;
    const target = String(siteId);

    const arr = Array.isArray(itemAccess)
      ? itemAccess.map(String)
      : itemAccess
      ? [String(itemAccess)]
      : [];

    return arr.includes(target);
  };

  handlePageChange = page => {
    this.setState({ currentPage: page, loading: true }, () => {
      this.props
        .findAllStock(
          this.state.siteSelected,
          this.state.currentPage,
          this.state.pageSize,
          '', // optional searchQuery
          this.state.selectedYear,
          this.state.selectedMonths // ✅ now passing months
        )
        .then(response => {
          const { stock, total } = response.data;
          this.setState({
            stockData: stock,
            totalStock: total,
            loading: false
          });
        })
        .catch(error => {
          this.setState({ loading: false });
          console.error('Page change failed', error);
        });
    });
  };

  handleCategoryChange = value => {
    this.setState({ selectedCategory: value || null }); // ✅ Reset to null when cleared
  };

  handleCategoryCostChange = value => {
    this.setState({ selectedCategoryCost: value });
  };

  handleCategoryRoomsChange = value => {
    this.setState({ selectedCategoryRooms: value });
  };

  handleYearChange = (date, dateString) => {
    const selectedYear = date ? date.format('YYYY') : null;

    this.setState({ selectedYear }, () => {
      this.fetchAllStock();
    });
  };
  normalizeCurrency = cur => {
    const c = String(cur || '')
      .trim()
      .toUpperCase();
    if (!c) return '';
    if (c === 'TZS') return 'TZS'; // alias
    return c;
  };

  convertToTargetCurrency = (amount, sourceSite, targetSite) => {
    const sourceCur = this.normalizeCurrency(sourceSite?.companyCurrency);
    const targetCur = this.normalizeCurrency(targetSite?.companyCurrency);

    const ex = targetSite?.exchange || {}; // { TZS: 0.00037, KSH: 0.0077, USD: 1, ... } (your data)
    const n = Number(amount) || 0;

    if (!sourceCur || !targetCur)
      return { currency: targetCur || sourceCur || 'USD', value: n };
    if (sourceCur === targetCur) return { currency: targetCur, value: n };

    const srcToUSD = Number(ex[sourceCur]); // 1 source = srcToUSD USD
    const tgtToUSD = Number(ex[targetCur]); // 1 target = tgtToUSD USD

    if (!srcToUSD || srcToUSD <= 0) return { currency: sourceCur, value: n };

    const usd = n * srcToUSD;

    if (targetCur === 'USD') return { currency: 'USD', value: usd };

    if (!tgtToUSD || tgtToUSD <= 0) return { currency: sourceCur, value: n };

    return { currency: targetCur, value: usd / tgtToUSD };
  };
  exportCompToExcel = (groupedDataComp, companyCurrency) => {
    if (!groupedDataComp || !groupedDataComp.length) {
      Notify('error', 'No room inclusion data to export');
      return;
    }

    const wsData = [
      [
        'Month',
        'Day',
        'Category',
        'Description',
        'Guest / Room',
        'Booking Number',
        'Comments',
        `Value (${companyCurrency})`
      ]
    ];

    let grandTotal = 0;

    groupedDataComp.forEach(monthRec => {
      const monthLabel = dayjs(monthRec.compMonth + '-01').format('MMM YYYY');

      Object.values(monthRec.records)
        .sort((a, b) => a.compDay.localeCompare(b.compDay))
        .forEach(dayRec => {
          dayRec.records.forEach(record => {
            const values = Array.isArray(record.compValue)
              ? record.compValue
              : [];

            values.forEach((val, idx) => {
              const category = (record.compCategory || [])[idx];
              if (
                this.state.selectedCompCategory &&
                category !== this.state.selectedCompCategory
              ) {
                return;
              }
              const amount = Number(val) || 0;
              grandTotal += amount;

              wsData.push([
                monthLabel,
                dayjs(dayRec.compDay).format('YYYY-MM-DD'),
                category || '',
                (record.compDescription || [])[idx] || '',
                (record.compGuest || [])[idx] || '',
                (record.compBookingNr || [])[idx] || '',
                (record.compComments || [])[idx] || '',
                amount
              ]);
            });
          });
        });
    });

    wsData.push([]);
    wsData.push(['', '', '', '', '', '', 'Total', grandTotal]);

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws['!cols'] = [
      { wch: 12 },
      { wch: 12 },
      { wch: 14 },
      { wch: 30 },
      { wch: 16 },
      { wch: 16 },
      { wch: 30 },
      { wch: 14 }
    ];

    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let c = range.s.c; c <= range.e.c; c++) {
      const addr = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[addr]) {
        ws[addr].s = {
          fill: { fgColor: { rgb: '000000' } },
          font: { color: { rgb: 'FFFFFF' }, bold: true },
          alignment: { horizontal: 'center' }
        };
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Room Inclusion');
    XLSX.writeFile(wb, 'Room Inclusion.xlsx', {
      bookType: 'xlsx',
      cellStyles: true
    });
  };

  exportSalesToExcel = groupedData => {
    const { siteSelected } = this.state;
    const companyCurrency =
      this.props.sites.find(s => s._id === siteSelected)?.companyCurrency ||
      'R';

    // 1) Build your 2D array: header + rows
    const wsData = [];
    // header row
    wsData.push([
      'Month',
      'Day',
      'Booking Number',
      'Category',
      'Extra Sales',
      'Cash',
      'Card',
      'Complimentary / Refund',
      'Bednights',
      'Balance',
      'Value per Sale',
      'Comments'
    ]);

    groupedData.forEach(monthRec => {
      const monthLabel = dayjs(monthRec.saleMonth).format('MMM YYYY');

      // monthRec.records is an object: { saleDayKey: dayRec, … }
      Object.values(monthRec.records).forEach(dayRec => {
        const dayLabel = dayjs(dayRec.saleDay).format('YYYY-MM-DD');

        dayRec.records.forEach(record => {
          // compute record-level totals
          const cashTotal = Array.isArray(record.saleCash)
            ? record.saleCash.reduce((a, b) => a + Number(b || 0), 0)
            : Number(record.saleCash || 0);
          const cardTotal = Array.isArray(record.saleCard)
            ? record.saleCard.reduce((a, b) => a + Number(b || 0), 0)
            : Number(record.saleCard || 0);
          const refundArr = Array.isArray(record.saleRefund)
            ? record.saleRefund
            : [record.saleRefund];
          const bednightsTotal = Array.isArray(record.saleBednights)
            ? record.saleBednights.reduce((a, b) => a + Number(b || 0), 0)
            : Number(record.saleBednights || 0);

          // balance = extraSalesTotal - (cash + card + refunds)
          const extraArr = Array.isArray(record.extraSales)
            ? record.extraSales
            : [record.extraSales];
          const extraTotal = extraArr.reduce((a, b) => a + Number(b || 0), 0);
          const refundTotal = refundArr.reduce((a, b) => a + Number(b || 0), 0);
          const balance = extraTotal - (cashTotal + cardTotal + refundTotal);

          // if saleCategory is array, one row per category; else single row
          const cats = Array.isArray(record.saleCategory)
            ? record.saleCategory
            : [record.saleCategory];

          cats.forEach((cat, idx) => {
            wsData.push([
              monthLabel,
              dayLabel,
              record.bookingNr,
              cat || '',
              `${companyCurrency} ${Number(extraArr[idx] || 0).toFixed(2)}`,
              `${companyCurrency} ${cashTotal.toFixed(2)}`,
              `${companyCurrency} ${cardTotal.toFixed(2)}`,
              `${companyCurrency} ${Number(refundArr[idx] || 0).toFixed(2)}`,
              bednightsTotal,
              `${companyCurrency} ${balance.toFixed(2)}`,
              `${companyCurrency} ${
                bednightsTotal > 0
                  ? (extraTotal / bednightsTotal).toFixed(2)
                  : '0.00'
              }`,
              Array.isArray(record.saleComments)
                ? record.saleComments[idx] || 'No Comments'
                : record.saleComments || 'No Comments'
            ]);
          });
        });
      });
    });

    // 2) Create worksheet & set column widths
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws['!cols'] = [
      { wch: 14 }, // Month
      { wch: 12 }, // Day
      { wch: 16 }, // Booking Number
      { wch: 14 }, // Category
      { wch: 12 }, // Extra Sales
      { wch: 10 }, // Cash
      { wch: 10 }, // Card
      { wch: 22 }, // Complimentary / Refund
      { wch: 10 }, // Bednights
      { wch: 12 }, // Balance
      { wch: 14 }, // Value per Sale
      { wch: 24 } // Comments
    ];

    // 3) Style header: black bg, white text
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let c = range.s.c; c <= range.e.c; ++c) {
      const addr = XLSX.utils.encode_cell({ r: 0, c });
      if (!ws[addr]) continue;
      ws[addr].s = {
        fill: { fgColor: { rgb: '000000' } },
        font: { color: { rgb: 'FFFFFF' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' }
      };
    }

    // 4) Highlight any Refund > 0 in red
    const refundCol = wsData[0].indexOf('Complimentary / Refund');
    if (refundCol > -1) {
      for (let r = 1; r <= range.e.r; ++r) {
        const addr = XLSX.utils.encode_cell({ r, c: refundCol });
        const cell = ws[addr];
        if (!cell || !cell.v) continue;
        // strip currency and parse
        const num = parseFloat(String(cell.v).replace(/[^0-9.-]+/g, ''));
        if (num > 0) {
          cell.s = {
            ...(cell.s || {}),
            fill: { fgColor: { rgb: 'FFC7CE' } }
          };
        }
      }
    }

    // 5) Build workbook & download
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sales Report');
    XLSX.writeFile(wb, `Sales-Report-${dayjs().format('YYYY-MM-DD')}.xlsx`, {
      bookType: 'xlsx',
      cellStyles: true
    });
  };
  exportCostRequestsToExcel = () => {
    const selectedSite = (this.props.sites || []).find(
      s => String(s._id) === String(this.state.siteSelected)
    );

    const inventorySite =
      (this.props.inventorySites || []).find(
        s => String(s._id) === String(this.state.inventoryCostSiteId)
      ) || selectedSite;

    const months = (this.state.selectedMonths || []).map(String);
    const selectedCat = this.state.selectedCategoryCost;

    const rows = (this.state.stockRequests || [])
      .filter(r => {
        if (!r.requestDate) return false;
        const mm = dayjs(r.requestDate).format('MM');
        const matchesMonth = months.length ? months.includes(mm) : true;
        const matchesCat =
          !selectedCat ||
          String(r.masterAllocation || '') === String(selectedCat);
        return matchesMonth && matchesCat;
      })
      .sort((a, b) => new Date(a.requestDate) - new Date(b.requestDate));

    const wsData = [
      [
        'Request Date',
        'Master Allocation',
        'Sub Allocation',
        'Item Name',
        'Requested From',
        'Total Cost',
        'MTD P/Bednight | P/Staff',
        'Bednights',
        'Staff On Site'
      ]
    ];

    rows.forEach(r => {
      const conv = this.convertToTargetCurrency(
        Number(r.totalCosts) || 0,
        inventorySite,
        selectedSite
      );

      const requestDay = dayjs(r.requestDate).format('YYYY-MM-DD');
      const roomRecord = (this.state.stockData || []).find(
        item =>
          item.roomsDate &&
          dayjs(item.roomsDate).format('YYYY-MM-DD') === requestDay &&
          item.access === this.state.siteSelected
      );
      const bednights = Number(roomRecord?.roomsPAX) || 0;
      const staffOnSite = Number(roomRecord?.staffOnSite) || 0;
      const isCanteen = r.masterAllocation === 'Staff Canteen Cost';
      const divisor = isCanteen ? staffOnSite : bednights;
      const perUnit = divisor > 0 ? (Number(r.totalCosts) || 0) / divisor : 0;
      const perUnitConv = this.convertToTargetCurrency(
        perUnit,
        inventorySite,
        selectedSite
      );
      const label = isCanteen ? 'P/Staff' : 'P/Bednight';

      wsData.push([
        r.requestDate ? dayjs(r.requestDate).format('YYYY-MM-DD HH:mm') : '',
        r.masterAllocation || '',
        r.subAllocation || '',
        r.itemName || '',
        r.requestedFrom || '',
        `${conv.currency} ${(Number(conv.value) || 0).toFixed(2)}`,
        `${perUnitConv.currency} ${(Number(perUnitConv.value) || 0).toFixed(
          2
        )} ${label}`,
        bednights,
        staffOnSite
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws['!cols'] = [
      { wch: 20 },
      { wch: 18 },
      { wch: 22 },
      { wch: 16 },
      { wch: 18 },
      { wch: 16 },
      { wch: 26 },
      { wch: 12 },
      { wch: 14 }
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Variable Cost');
    XLSX.writeFile(wb, `Variable-Cost-${dayjs().format('YYYY-MM-DD')}.xlsx`, {
      bookType: 'xlsx',
      cellStyles: true
    });
  };
  exportCostToExcel = groupedDataCost => {
    // 1) Grab your currency symbol once
    const companyCurrency =
      this.props.sites.find(s => s._id === this.state.siteSelected)
        ?.companyCurrency || 'R';

    // 2) Build a 2D array: [ [header…], [row1…], [row2…], … ]
    const wsData = [
      [
        'Month',
        'Day',
        'Category',
        'Cost P/Person',
        'Cost',
        'Daily Budget',
        'Comments'
      ]
    ];

    groupedDataCost.forEach(monthRec => {
      const monthLabel = dayjs(monthRec.costMonth).format('MMM YYYY');

      Object.values(monthRec.records).forEach(dayRec => {
        const dayLabel = dayjs(dayRec.costDay).format('YYYY-MM-DD');

        dayRec.records.forEach(record => {
          // for each category in this record, push a row
          if (Array.isArray(record.costCategory)) {
            record.costCategory.forEach((cat, i) => {
              const cpp = Array.isArray(record.costPerPerson)
                ? record.costPerPerson[i]
                : record.costPerPerson;
              const price = Array.isArray(record.costPrice)
                ? record.costPrice[i]
                : record.costPrice;
              const budget = Array.isArray(record.dailyBudget)
                ? record.dailyBudget[i]
                : record.dailyBudget;
              const comments = Array.isArray(record.costComments)
                ? record.costComments[i]
                : record.costComments;

              wsData.push([
                monthLabel,
                dayLabel,
                cat || '',
                `${companyCurrency} ${(Number(cpp) || 0).toFixed(2)}`,
                `${companyCurrency} ${(Number(price) || 0).toFixed(2)}`,
                `${companyCurrency} ${(Number(budget) || 0).toFixed(2)}`,
                comments || ''
              ]);
            });
          }
        });
      });
    });

    // 3) Turn that into a worksheet, set column widths
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws['!cols'] = [
      { wch: 14 }, // Month
      { wch: 12 }, // Day
      { wch: 16 }, // Category
      { wch: 14 }, // Cost P/Person
      { wch: 12 }, // Cost
      { wch: 14 }, // Daily Budget
      { wch: 24 } // Comments
    ];

    // 4) Style header row black + white text
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let c = range.s.c; c <= range.e.c; c++) {
      const addr = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[addr]) {
        ws[addr].s = {
          fill: { fgColor: { rgb: '000000' } },
          font: { color: { rgb: 'FFFFFF' }, bold: true },
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }
    }

    // 5) Highlight “Cost” > “Daily Budget” in red
    const costCol = wsData[0].indexOf('Cost');
    const budgetCol = wsData[0].indexOf('Daily Budget');
    if (costCol > -1 && budgetCol > -1) {
      for (let r = 1; r <= range.e.r; r++) {
        const costAddr = XLSX.utils.encode_cell({ r, c: costCol });
        const budgetAddr = XLSX.utils.encode_cell({ r, c: budgetCol });
        const costCell = ws[costAddr];
        const budgetCell = ws[budgetAddr];
        if (costCell && budgetCell) {
          const parseNum = v =>
            parseFloat(String(v).replace(/[^0-9.-]+/g, '')) || 0;
          const costVal = parseNum(costCell.v);
          const budgetVal = parseNum(budgetCell.v);
          if (costVal > budgetVal) {
            costCell.s = {
              ...(costCell.s || {}),
              fill: { fgColor: { rgb: 'FFC7CE' } }
            };
          }
        }
      }
    }

    // 6) Build the workbook and save
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cost Report');
    XLSX.writeFile(wb, `Cost-Report-${dayjs().format('YYYY-MM-DD')}.xlsx`, {
      bookType: 'xlsx',
      cellStyles: true
    });
  };

  render() {
    const {
      open,
      openSteps,
      steps,
      selectedCategory,
      selectedCategoryCost,
      selectedCategoryRooms,
      selectedYear
    } = this.state;

    let descriptions = this.props.stock.map(vehicle => {
      return { value: vehicle.description };
    });
    const { collection, searchText } = this.state;
    const { stock } = this.props;
    let vehicles;
    if (this.state.currentTab === 'All') {
      vehicles = stock;
    } else {
      vehicles = stock.filter(
        vehicle => vehicle.collection === this.state.currentTab
      );
    }

    const filteredStockData = this.state.stockData.filter(
      item =>
        item.saleCategory &&
        (!this.state.selectedCategory ||
          item.saleCategory.includes(this.state.selectedCategory)) &&
        item.access &&
        this.state.siteSelected &&
        item.saleDate &&
        item.access.toLowerCase() === this.state.siteSelected.toLowerCase() &&
        (!this.state.selectedYear ||
          dayjs(item.saleDate).format('YYYY') === this.state.selectedYear)
    );
    const groupedData = Object.entries(
      filteredStockData.reduce((acc, item) => {
        const saleMonth = dayjs(item.saleDate).format('YYYY-MM'); // Group by month
        const saleDay = dayjs(item.saleDate).format('YYYY-MM-DD'); // Group by day

        if (!acc[saleMonth]) {
          acc[saleMonth] = {
            saleMonth,
            records: {},
            totals: {
              cashSales: 0,
              cardSales: 0,
              bednights: 0,
              refunds: 0,
              extraSales: 0,
              totalIncome: 0
            }
          };
        }

        if (!acc[saleMonth].records[saleDay]) {
          acc[saleMonth].records[saleDay] = {
            saleDay,
            records: [],
            totals: {
              cashSales: 0,
              cardSales: 0,
              bednights: 0,
              refunds: 0,
              extraSales: 0,
              totalIncome: 0
            }
          };
        }

        // **Apply category filtering**
        if (
          !this.state.selectedCategory ||
          item.saleCategory.includes(this.state.selectedCategory)
        ) {
          const sumArrayValues = (arr, categoryIndex = null) => {
            if (Array.isArray(arr)) {
              return categoryIndex !== null
                ? Number(arr[categoryIndex]) || 0
                : arr.reduce((sum, val) => sum + (val || 0), 0);
            }
            return 0;
          };
          let categoryIndex = null;
          if (this.state.selectedCategory && Array.isArray(item.saleCategory)) {
            categoryIndex = item.saleCategory.indexOf(
              this.state.selectedCategory
            );
          }

          const extraSalesTotal = sumArrayValues(
            item.extraSales,
            categoryIndex
          );

          const refundTotal = sumArrayValues(item.saleRefund, categoryIndex);

          const cashTotal = Number(item.saleCash) || 0;
          const cardTotal = Number(item.saleCard) || 0;

          const bednightsTotal = Number(item.saleBednights) || 0;

          acc[saleMonth].records[saleDay].records.push(item);

          // **Day-Level Totals**
          acc[saleMonth].records[saleDay].totals.extraSales += extraSalesTotal;
          acc[saleMonth].records[saleDay].totals.cashSales += cashTotal;
          acc[saleMonth].records[saleDay].totals.cardSales += cardTotal;
          acc[saleMonth].records[saleDay].totals.bednights += bednightsTotal;
          acc[saleMonth].records[saleDay].totals.refunds += refundTotal;
          acc[saleMonth].records[saleDay].totals.totalIncome +=
            extraSalesTotal - refundTotal - (cashTotal + cardTotal);

          // **Month-Level Totals**
          acc[saleMonth].totals.extraSales += extraSalesTotal;
          acc[saleMonth].totals.cashSales += cashTotal;
          acc[saleMonth].totals.cardSales += cardTotal;
          acc[saleMonth].totals.bednights += bednightsTotal;
          acc[saleMonth].totals.refunds += refundTotal;
          acc[saleMonth].totals.totalIncome +=
            extraSalesTotal - refundTotal - (cashTotal + cardTotal);
        }

        return acc;
      }, {})
    ).map(([_, group]) => group);

    // Complimentary — same month -> day -> record shape as Sales, but the only
    // aggregates that matter are what was given away and how many items.
    const compCurrency =
      this.props.sites.find(s => s._id === this.state.siteSelected)
        ?.companyCurrency || 'R';

    const filteredStockDataComp = this.state.stockData.filter(
      item =>
        item.access &&
        this.state.siteSelected &&
        item.compDate &&
        item.access.toLowerCase() === this.state.siteSelected.toLowerCase() &&
        (!this.state.selectedYear ||
          dayjs(item.compDate).format('YYYY') === this.state.selectedYear)
    );

    const groupedDataComp = Object.entries(
      filteredStockDataComp.reduce((acc, item) => {
        const categories = Array.isArray(item.compCategory)
          ? item.compCategory
          : [];
        const values = Array.isArray(item.compValue) ? item.compValue : [];

        // Total only the line items matching the category filter, if one is set.
        let valueTotal = 0;
        let countTotal = 0;
        values.forEach((val, index) => {
          if (
            this.state.selectedCompCategory &&
            categories[index] !== this.state.selectedCompCategory
          ) {
            return;
          }
          valueTotal += Number(val) || 0;
          countTotal += 1;
        });

        // Nothing on this record matches the filter, so don't create an empty
        // month/day bucket for it.
        if (this.state.selectedCompCategory && countTotal === 0) {
          return acc;
        }

        const compMonth = dayjs(item.compDate).format('YYYY-MM');
        const compDay = dayjs(item.compDate).format('YYYY-MM-DD');

        if (!acc[compMonth]) {
          acc[compMonth] = {
            compMonth,
            records: {},
            totals: { compValue: 0, compCount: 0 }
          };
        }

        if (!acc[compMonth].records[compDay]) {
          acc[compMonth].records[compDay] = {
            compDay,
            records: [],
            totals: { compValue: 0, compCount: 0 }
          };
        }

        acc[compMonth].records[compDay].records.push(item);
        acc[compMonth].records[compDay].totals.compValue += valueTotal;
        acc[compMonth].records[compDay].totals.compCount += countTotal;
        acc[compMonth].totals.compValue += valueTotal;
        acc[compMonth].totals.compCount += countTotal;

        return acc;
      }, {})
    )
      .map(([_, group]) => group)
      .sort((a, b) => a.compMonth.localeCompare(b.compMonth));

    // Flatten a day's records into individual complimentary line items.
    const compLineItems = dayRecord =>
      (dayRecord.records || []).flatMap(record => {
        const values = Array.isArray(record.compValue) ? record.compValue : [];
        return values
          .map((val, index) => ({
            key: `${record._id}-${index}`,
            compCategory: (record.compCategory || [])[index],
            compDescription: (record.compDescription || [])[index],
            compValue: Number(val) || 0,
            compGuest: (record.compGuest || [])[index],
            compBookingNr: (record.compBookingNr || [])[index],
            compComments: (record.compComments || [])[index]
          }))
          .filter(
            row =>
              !this.state.selectedCompCategory ||
              row.compCategory === this.state.selectedCompCategory
          );
      });

    const filteredStockDataCost = this.state.stockData.filter(
      item =>
        Array.isArray(item.costCategory) && // ✅ Ensure costCategory is an array
        item.access &&
        this.state.siteSelected &&
        item.costDate &&
        item.access.toLowerCase() === this.state.siteSelected.toLowerCase() &&
        (!this.state.selectedYear ||
          dayjs(item.costDate).format('YYYY') === this.state.selectedYear)
    );
    const groupedDataCost = Object.entries(
      filteredStockDataCost.reduce((acc, item) => {
        const costMonth = dayjs(item.costDate).format('YYYY-MM'); // Group by month
        const costDay = dayjs(item.costDate).format('YYYY-MM-DD'); // Group by day

        if (!acc[costMonth]) {
          acc[costMonth] = {
            costMonth,
            records: {},
            totals: {
              rooms: 0,
              roomsAvail: 0,
              roomsBlocked: 0,
              pax: 0,
              costPrice: 0,
              costBudget: 0,
              costPerPerson: 0,
              totalCost: 0,
              totalCostPerPAX: 0,
              totalOccupancy: 0 // ✅ Store cumulative occupancy
            }
          };
        }

        if (!acc[costMonth].records[costDay]) {
          acc[costMonth].records[costDay] = {
            costDay,
            records: [],
            totals: {
              rooms: 0,
              roomsAvail: 0,
              roomsBlocked: 0,
              pax: 0,
              costPrice: 0,
              costBudget: 0,
              costPerPerson: 0,
              totalCost: 0,
              totalCostPerPAX: 0,
              totalOccupancy: 0 // ✅ Store cumulative occupancy
            }
          };
        }
        if (
          !this.state.selectedCategoryCost ||
          (Array.isArray(item.costCategory) &&
            item.costCategory.includes(this.state.selectedCategoryCost))
        ) {
          // ✅ Helper Function to Sum Values (Handles both Arrays & Single Values)
          const sumValues = (value, categoryIndex = null) => {
            if (Array.isArray(value)) {
              return categoryIndex !== null && categoryIndex >= 0
                ? Number(value[categoryIndex]) || 0
                : value.reduce((sum, val) => sum + (Number(val) || 0), 0);
            }
            return Number(value) || 0; // ✅ If single value, return it
          };

          // ✅ Get Index of Selected Category (For Array Fields Only)
          let categoryIndex = null;
          if (
            this.state.selectedCategoryCost &&
            Array.isArray(item.costCategory)
          ) {
            categoryIndex = item.costCategory.indexOf(
              this.state.selectedCategoryCost
            );
            if (categoryIndex === -1) return acc; // ✅ Skip if category not found
          }

          // ✅ Correctly Extract Values (Handles Arrays & Non-Arrays)
          const costPriceTotal = sumValues(item.costPrice, categoryIndex);
          const costPerPersonTotal = sumValues(
            item.costPerPerson,
            categoryIndex
          );
          const costBudgetTotal = sumValues(item.costBudget);
          const paxTotal = sumValues(item.costPAX); // Not an array
          // Staff Canteen Cost is per staff on site (per day), not per PAX
          const isStaffCanteenCategory =
            this.state.selectedCategoryCost === 'Staff Canteen Cost';
          const costPerDivisor = isStaffCanteenCategory
            ? sumValues(item.costStaffOnSite) || paxTotal
            : paxTotal;
          const roomsTotal = sumValues(item.costRooms); // Not an array
          const roomsAvailTotal = sumValues(item.costRoomsAvail); // Not an array
          const occupancyRate =
            roomsAvailTotal > 0 ? (roomsTotal / roomsAvailTotal) * 100 : 0;

          // ✅ Store the Item
          acc[costMonth].records[costDay].records.push(item);

          // ✅ Update Day-Level Totals (SUMS)
          acc[costMonth].records[costDay].totals.costPrice += costPriceTotal;
          acc[costMonth].records[
            costDay
          ].totals.costPerPerson += costPerPersonTotal;
          acc[costMonth].records[costDay].totals.totalCost += costPriceTotal;
          acc[costMonth].records[costDay].totals.totalCostPerPAX +=
            costPerDivisor > 0 ? costPriceTotal / costPerDivisor : 0;
          acc[costMonth].records[costDay].totals.pax += paxTotal;
          acc[costMonth].records[costDay].totals.costBudget += costBudgetTotal;
          acc[costMonth].records[costDay].totals.rooms += roomsTotal;
          acc[costMonth].records[costDay].totals.roomsAvail += roomsAvailTotal;
          acc[costMonth].records[costDay].totals.totalOccupancy += roomsTotal; // ✅ Accumulate booked rooms

          // ✅ Update Month-Level Totals (SUMS)
          acc[costMonth].totals.costPrice += costPriceTotal;
          acc[costMonth].totals.costPerPerson += costPerPersonTotal;
          acc[costMonth].totals.totalCost += costPriceTotal;
          acc[costMonth].totals.totalCostPerPAX +=
            costPerDivisor > 0 ? costPriceTotal / costPerDivisor : 0;
          acc[costMonth].totals.costBudget += costBudgetTotal;
          acc[costMonth].totals.pax += paxTotal;
          acc[costMonth].totals.rooms += roomsTotal;
          acc[costMonth].totals.roomsAvail += roomsAvailTotal;
          acc[costMonth].totals.totalOccupancy += roomsTotal; // ✅ Accumulate booked rooms
        }
        return acc;
      }, {})
    ).map(([_, group]) => {
      // ✅ Calculate Final Averages at Month Level
      if (group.totals.roomsAvail > 0) {
        group.totals.occupancy = (
          (group.totals.totalOccupancy / group.totals.roomsAvail) *
          100
        ).toFixed(2);
      } else {
        group.totals.occupancy = 0; // ✅ Prevent NaN
      }

      // ✅ Calculate Final Averages at Day Level
      Object.values(group.records).forEach(dayRecord => {
        if (dayRecord.totals.roomsAvail > 0) {
          dayRecord.totals.occupancy = (
            (dayRecord.totals.totalOccupancy / dayRecord.totals.roomsAvail) *
            100
          ).toFixed(2);
        } else {
          dayRecord.totals.occupancy = 0; // ✅ Prevent NaN
        }
      });

      return group;
    });

    const groupedDataRooms = Object.entries(
      this.state.stockData
        .filter(
          item =>
            item.access &&
            this.state.siteSelected &&
            item.roomsDate &&
            item.access.toLowerCase() ===
              this.state.siteSelected.toLowerCase() &&
            (!this.state.selectedYear ||
              dayjs(item.roomsDate).format('YYYY') === this.state.selectedYear) // Month check
        ) // Filter items based on siteSelected
        .reduce((acc, item) => {
          const monthKey = item.roomsDate
            ? dayjs(item.roomsDate).format('YYYY-MM') // Group by month (e.g., 2024-11)
            : 'Unknown Month';

          if (!acc[monthKey]) {
            acc[monthKey] = {
              month: monthKey,
              roomsData: [], // Store individual records for the group
              totals: {
                roomsAvail: 0,
                roomsBooked: 0,
                roomsBlocked: 0,
                roomsPAX: 0,
                guideMeals: 0,
                refunds: 0,
                occupancy: 0
              }
            };
          }

          acc[monthKey].roomsData.push(item);

          // Aggregate totals for the group
          acc[monthKey].totals.roomsAvail += item.roomsAvail || 0;
          acc[monthKey].totals.roomsBooked += item.roomsBooked || 0;
          acc[monthKey].totals.roomsBlocked += item.roomsBlocked || 0;
          acc[monthKey].totals.roomsPAX += item.roomsPAX || 0;
          acc[monthKey].totals.guideMeals += Number(item.guideMeals) || 0;
          acc[monthKey].totals.refunds += item.roomsRefund || 0;

          // Calculate occupancy
          if (item.roomsAvail && item.roomsBooked) {
            const availableRooms = acc[monthKey].totals.roomsAvail || 0;
            const blockedRooms = acc[monthKey].totals.roomsBlocked || 0;

            if (availableRooms - blockedRooms > 0) {
              acc[monthKey].totals.occupancy = Math.round(
                (acc[monthKey].totals.roomsBooked /
                  (availableRooms - blockedRooms)) *
                  100
              );
            } else {
              acc[monthKey].totals.occupancy = 0; // Prevent division by zero
            }
          }

          return acc;
        }, {})
    )
      // Sort groups by month
      .sort(([monthA], [monthB]) => {
        if (monthA === 'Unknown Month') return 1; // Place 'Unknown Month' at the end
        if (monthB === 'Unknown Month') return -1;
        return new Date(monthA) - new Date(monthB); // Ascending order
      })
      .map(([_, group]) => group); // Extract grouped data

    const filteredData = groupedData.filter(item => {
      const matchesCategory =
        !selectedCategory || selectedCategory.includes(item.saleCategory);
      const matchesMonth =
        !selectedYear || dayjs(item.saleDate).format('YYYY') === selectedYear;

      return matchesCategory && matchesMonth;
    });
    const filteredDataCost = groupedDataCost.filter(item => {
      const matchesCategory =
        !selectedCategoryCost || item.costCategory === selectedCategoryCost;
      const matchesMonth =
        !selectedYear || dayjs(item.costDate).format('YYYY') === selectedYear;

      return matchesCategory && matchesMonth;
    });

    const filteredDataRooms = groupedDataRooms.filter(group => {
      const matchesCategory =
        !selectedCategoryRooms ||
        group.roomsData.some(
          item => item.roomsCategory === selectedCategoryRooms
        ); // Check category within grouped records

      const matchesMonth = !selectedYear || group.month === selectedYear; // Compare group month directly

      return matchesCategory && matchesMonth;
    });

    const matchesYearAndMonth = date => {
      const itemYear = dayjs(date).format('YYYY');
      const itemMonth = dayjs(date).format('MM');

      const selectedYear = this.state.selectedYear || dayjs().format('YYYY');
      const selectedMonths =
        this.state.selectedMonths && this.state.selectedMonths.length > 0
          ? this.state.selectedMonths.map(String)
          : [dayjs().format('MM')];

      return itemYear === selectedYear && selectedMonths.includes(itemMonth);
    };

    const filteredRooms = this.state.stockData.filter(
      item =>
        item.roomsDate &&
        matchesYearAndMonth(item.roomsDate) &&
        (this.state.siteSelected
          ? item.access === this.state.siteSelected
          : true)
    );
    const bednightsMTD = filteredRooms.reduce((sum, item) => {
      const roomsPAX = Array.isArray(item.roomsPAX)
        ? item.roomsPAX.reduce((total, val) => total + (Number(val) || 0), 0)
        : Number(item.roomsPAX) || 0;

      return sum + roomsPAX;
    }, 0);
    const monthsSelected = (this.state.selectedMonths || []).map(String);
    const cat = this.state.selectedCategoryCost;

    const selectedSite = (this.props.sites || []).find(
      s => String(s._id) === String(this.state.siteSelected)
    );

    const inventorySite = (this.props.inventorySites || []).find(
      s => String(s._id) === String(this.state.inventoryCostSiteId)
    );

    // flat filtered rows
    const rows = (this.state.stockRequests || []).filter(r => {
      if (!r.requestDate) return false;

      const mm = dayjs(r.requestDate).format('MM');
      const matchesMonth = monthsSelected.includes(mm);

      const matchesCat =
        !cat || String(r.masterAllocation || '') === String(cat);

      return matchesMonth && matchesCat;
    });

    // group Month -> Day
    const monthMap = rows.reduce((acc, r) => {
      const monthKey = dayjs(r.requestDate).format('YYYY-MM');
      const dayKey = dayjs(r.requestDate).format('YYYY-MM-DD');

      if (!acc[monthKey]) acc[monthKey] = {};
      if (!acc[monthKey][dayKey]) acc[monthKey][dayKey] = [];

      acc[monthKey][dayKey].push(r);
      return acc;
    }, {});

    // helper to calc converted total
    const sumConverted = arr =>
      (arr || []).reduce((sum, r) => {
        const conv = this.convertToTargetCurrency(
          Number(r.totalCosts) || 0,
          inventorySite,
          selectedSite
        );
        return sum + (Number(conv.value) || 0);
      }, 0);

    // build final monthData
    const monthData = Object.keys(monthMap)
      .sort((a, b) => a.localeCompare(b))
      .map(monthKey => {
        const dayObj = monthMap[monthKey];

        const dayRows = Object.keys(dayObj)
          .sort((a, b) => a.localeCompare(b))
          .map(dayKey => {
            const dayItems = (dayObj[dayKey] || [])
              .slice()
              .sort(
                (a, b) => new Date(a.requestDate) - new Date(b.requestDate)
              );

            return {
              _id: `${monthKey}-${dayKey}`,
              dayKey,
              dayLabel: dayjs(dayKey).format('YYYY-MM-DD'),
              dayTotal: sumConverted(dayItems),
              currency: this.convertToTargetCurrency(
                0,
                inventorySite,
                selectedSite
              ).currency,
              records: dayItems
            };
          });

        const monthTotal = dayRows.reduce(
          (s, d) => s + (Number(d.dayTotal) || 0),
          0
        );

        return {
          _id: monthKey,
          monthKey,
          monthLabel: dayjs(monthKey + '-01').format('MMM YYYY'),
          monthTotal,
          currency: this.convertToTargetCurrency(0, inventorySite, selectedSite)
            .currency,
          records: dayRows // ✅ days live here
        };
      });
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <Spin spinning={this.state.loading}>
          <Tour
            open={openSteps}
            onClose={() => this.setState({ openSteps: false })}
            steps={steps}
          />

          {this.state.previewVisible ||
          this.state.costVisible ||
          this.state.roomsVisible ||
          this.state.compVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    // 75em of padding is a desktop spacer to left-align the
                    // title; on a phone it forces a horizontal scrollbar.
                    paddingRight: this.props.isMobile ? 0 : '75em',
                    fontSize: this.props.isMobile ? '17px' : '20px',
                    fontWeight: 800,
                    whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                    fontFamily: 'Nunito'
                  }}
                >
                  {this.state.editStock ? 'Edit Item' : 'Add Item'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: this.props.isMobile ? '13px' : '16px',
                      whiteSpace: this.props.isMobile ? 'normal' : 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editStock
                      ? 'Complete all required fields and click Save to publish'
                      : 'Complete all required fields and click Save to publish'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <StockForm
                  isMobile={this.props.isMobile}
                  bednightsMTD={bednightsMTD}
                  handleDeleteImage={this.handleDeleteImage}
                  handleDeleteImage2={this.handleDeleteImage2}
                  duplicateModal={this.state.duplicateModal}
                  siteSelected={this.state.siteSelected}
                  previewVisibleVariant={this.state.previewVisibleVariant}
                  previewVisible={this.state.previewVisible}
                  costVisible={this.state.costVisible}
                  roomsVisible={this.state.roomsVisible}
                  compVisible={this.state.compVisible}
                  stock={this.state.stockData}
                  sites={this.props.sites}
                  editStock={this.state.editStock}
                  wrappedComponentRef={form => (this.stockForm = form)}
                />
                {/* <Tooltip placement="left" title="Back">
                  <FloatButton
                    style={{
                      right: 24,
                      bottom: '7.3em'
                    }}
                    onClick={e =>
                      this.setState({
                        siteSelected: this.state.siteSelected,
                        previewVisibleVariant: false,
                        previewVisible: false,
                        costVisible: false,
                        roomsVisible: false,
                        editStock: undefined
                      })
                    }
                    icon={<ArrowLeftOutlined style={{ color: 'black' }} />}
                  />
                </Tooltip> */}
                {this.props.isMobile ? (
                  <MobileEditActions>
                    <Button
                      size="large"
                      icon={<StopFilled />}
                      onClick={this.closeStockForm}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      icon={<CheckOutlined />}
                      onClick={this.handleAddStock}
                    >
                      {this.state.editStock ? 'Save Changes' : 'Save Item'}
                    </Button>
                  </MobileEditActions>
                ) : (
                  <FloatButton.Group
                    trigger="hover"
                    type="primary"
                    style={{ right: 24 }}
                    icon={<RocketFilled />}
                  >
                    <Tooltip placement="left" title="Save Item">
                      <FloatButton
                        onClick={this.handleAddStock}
                        icon={<PlusCircleFilled style={{ color: '#80CE90' }} />}
                      />
                    </Tooltip>
                    <Tooltip placement="left" title="Cancel">
                      <FloatButton
                        onClick={this.closeStockForm}
                        icon={<StopFilled style={{ color: 'red' }} />}
                      />
                    </Tooltip>
                  </FloatButton.Group>
                )}
              </div>
            </Cards>
          ) : (
            <>
            <MobileStockNavigation
              value={this.state.activeTabKey}
              onChange={event =>
                this.handleStockTabChange(event.target.value)
              }
              buttonStyle="solid"
            >
              <Radio.Button value="Variable Rooms">
                Variable Rooms
              </Radio.Button>
              <Radio.Button value="Sales">Sales</Radio.Button>
              <Radio.Button value="Variable Cost">
                Variable Cost
              </Radio.Button>
              <Radio.Button value="Complimentary">
                Room Inclusion
              </Radio.Button>
            </MobileStockNavigation>
            <StyledTabs
              className="stock-management-tabs"
              tabBarExtraContent={
                <StockFilters>
                  <Tag
                    className="stock-pax-filter"
                    color="green"
                    style={{
                      marginBottom: '0em',
                      fontSize: '14px',
                      fontWeight: 600,
                      padding: '0.4em',
                      fontFamily: 'Nunito',
                      marginTop: '0.3em',
                      display: 'inline-block',
                      color: 'tgrey',
                      marginRight: '1em'
                    }}
                  >
                    PAX (MTD): {bednightsMTD}
                  </Tag>

                  <Select
                    className="stock-site-filter"
                    size="large"
                    defaultValue={this.state.siteSelected} // Bind selected values to state
                    showSearch
                    onChange={values => {
                      this.props.setSelectedSite(values);
                      this.setState({ siteSelected: values }, () => {
                        this.handleSearchName();
                      });
                    }}
                    style={{
                      marginRight: this.props.isMobile ? 0 : '1.2em',
                      width: this.props.isMobile ? '100%' : '12em',
                      marginBottom: this.props.isMobile ? '1em' : '',
                    }}
                    placeholder="Select Company"
                    optionFilterProp="children"
                  >
                    {/* <Select.Option key="Admin" value="Admin">
                          Admin
                        </Select.Option> */}
                    {/* Options for sites */}
                    {this.props.sites.map(site => (
                      <Option key={site._id} value={site._id}>
                        {site.name}
                      </Option>
                    ))}
                  </Select>

                  <DatePicker
                    className="stock-year-filter"
                    picker="year"
                    size="large"
                    format="YYYY"
                    placeholder="Select Month"
                    onChange={this.handleYearChange}
                    defaultValue={
                      this.state.selectedYear
                        ? dayjs(this.state.selectedYear)
                        : dayjs()
                    } // Automatically sets to the current month
                    style={{
                      marginRight: this.props.isMobile ? 0 : '1.2em',
                      width: this.props.isMobile ? '100%' : 140,
                      marginBottom: this.props.isMobile ? '1em' : 0
                    }}
                    allowClear={false}
                  />
                  <Select
                    className="stock-month-filter"
                    style={{
                      width: this.props.isMobile ? '100%' : '23.5em',
                      float: this.props.isMobile ? 'none' : 'right'
                    }}
                    size="large"
                    mode="multiple"
                    placeholder="Select Months"
                    value={this.state.selectedMonths}
                    onChange={selectedMonths => {
                      if (selectedMonths.length === 0) {
                        message.warning(
                          'At least one month must remain selected.'
                        );
                        return;
                      }

                      this.setState({ selectedMonths }, async () => {
                        this.setState({ loading: true });
                        await this.handleSearchName();
                        this.setState({ loading: false });
                      });
                    }}
                  >
                    {Array.from({ length: 12 }, (_, i) => {
                      const monthValue = `${String(i + 1).padStart(2, '0')}`;
                      return (
                        <Select.Option key={monthValue} value={monthValue}>
                          {dayjs()
                            .month(i)
                            .format('MMMM')}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </StockFilters>
              }
              style={{ marginTop: '1em' }}
              animated={true}
              activeKey={this.state.activeTabKey} // Track the active tab
              onChange={this.handleStockTabChange}
            >
              <TabPane tab="Variable Rooms" key="Variable Rooms">
                <Row style={{ marginTop: '1em' }}>
                  <Col xs={24} lg={6}>
                    <h1
                      style={{
                        marginBottom: '0em',
                        fontSize: '22px',
                        fontWeight: 800,
                        fontFamily: 'Nunito',
                        marginTop: '0.3em'
                      }}
                    >
                      Rooms Management
                    </h1>
                  </Col>
                  <Col xs={24} lg={18}>
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.6em',
                        justifyContent: this.props.isMobile
                          ? 'flex-start'
                          : 'flex-end',
                        marginTop: this.props.isMobile ? '0.75em' : 0
                      }}
                    >
                      {/* <Select
                        size="large"
                        defaultValue={this.state.siteSelected} // Bind selected values to state
                        showSearch

                        onChange={values => {
                          this.props.setSelectedSite(values);
                          this.setState({ siteSelected: values }, () => {
                            this.handleSearchName();
                          });
                        }}
                        style={{
                          width: this.props.isMobile ? '100%' : '12em'
                        }}
                        placeholder="Select Company"
                        optionFilterProp="children"
                      >

                        {this.props.sites.map(site => (
                          <Option key={site._id} value={site._id}>
                            {site.name}
                          </Option>
                        ))}
                      </Select>

                      <DatePicker
                        picker="year"
                        size="large"
                        format="YYYY"
                        placeholder="Select Month"
                        onChange={this.handleYearChange}
                        defaultValue={this.state.selectedYear ? dayjs(this.state.selectedYear) : dayjs()}  // Automatically sets to the current month
                        style={{ marginRight: "1.2em", width: 140 }}
                        allowClear
                      /> */}

                      <Button
                        ref={this.ref}
                        type="primary"
                        onClick={this.onAddStockRooms}
                        icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                        size="large"
                        style={{
                          width: this.props.isMobile ? '100%' : 'auto'
                        }}
                      >
                        Add Rooms
                      </Button>
                    </div>
                  </Col>

                  <Col span={24}>
                    <MobileTableHelp>
                      <strong>SWIPE</strong>
                      Swipe sideways for more columns. Tap + to open details.
                    </MobileTableHelp>
                    <StyledTable
                      bordered={false}
                      dataSource={groupedDataRooms} // Use filtered data for the table
                      // pagination={{
                      //   current: this.state.currentPage,
                      //   pageSize: this.state.pageSize,
                      //   total: groupedDataRooms.length, // Total groups after filtering
                      //   onChange: this.handlePageChange,
                      // }}
                      rowKey={record => `${record.month}-${record._id}`}
                      size="middle"
                      style={{
                        minWidth: '15em',
                        marginTop: '1em'
                      }}
                      scroll={{
                        x: 800
                      }}
                      expandable={{
                        expandedRowRender: group => (
                          <StyledTableExpanded
                            dataSource={group.roomsData}
                            pagination={false}
                            rowKey={item => item._id}
                            columns={[
                              {
                                title: 'Date',
                                dataIndex: 'roomsDate',
                                key: 'roomsDate',
                                render: (text, record) =>
                                  record.roomsDate ? (
                                    dayjs(record.roomsDate).format('DD-MM-YYYY')
                                  ) : (
                                    <div>No Date</div>
                                  )
                              },
                              {
                                title: 'Staff Ons Site',
                                dataIndex: 'staffOnSite',
                                key: 'staffOnSite'
                              },
                              {
                                title: 'Rooms Available',
                                dataIndex: 'roomsAvail',
                                key: 'roomsAvail'
                              },
                              {
                                title: 'Rooms Booked',
                                dataIndex: 'roomsBooked',
                                key: 'roomsBooked'
                              },
                              {
                                title: 'Rooms Blocked',
                                dataIndex: 'roomsBlocked',
                                key: 'roomsBlocked'
                              },
                              {
                                title: 'Rooms PAX',
                                dataIndex: 'roomsPAX',
                                key: 'roomsPAX'
                              },
                              {
                                title: 'Guide Meals',
                                dataIndex: 'guideMeals',
                                key: 'guideMeals'
                              },
                              {
                                title: 'Occupancy %',
                                dataIndex: 'roomOccupancy',
                                key: 'roomOccupancy',
                                render: (text, record) => {
                                  const value = record.roomOccupancy; // Extract the value
                                  return (
                                    <span>
                                      {value != null && !isNaN(value)
                                        ? `${value.toFixed(0)}%`
                                        : '-'}{' '}
                                      {/* Check if value is valid */}
                                    </span>
                                  );
                                }
                              },
                              // {
                              //   title: 'Category',
                              //   dataIndex: 'saleCategory',
                              //   key: 'saleCategory',
                              // },

                              {
                                title: 'Actions',
                                fixed: 'right',
                                width: 96,
                                render: (text, stock) => (
                                  <span>
                                    <Tooltip
                                      placement="top"
                                      title="Edit Details"
                                    >
                                      <EditFilled
                                        style={{
                                          backgroundColor: '#80CE90',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}
                                        onClick={e => {
                                          e.stopPropagation(); // Prevent row click event
                                          this.handleEditStockRooms(stock);
                                        }}
                                      />
                                    </Tooltip>

                                    <Divider type="vertical" />
                                    <Tooltip
                                      placement="top"
                                      title="Delete Sale"
                                    >
                                      <DeleteFilled
                                        style={{
                                          backgroundColor: 'crimson',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}
                                        onClick={e => {
                                          e.stopPropagation(); // Prevent row click event
                                          this.setState({
                                            deleteVisible: true,
                                            deleteStock: stock
                                          });
                                        }}
                                      />
                                    </Tooltip>
                                  </span>
                                )
                              }
                            ]}
                          />
                        )
                      }}
                    >
                      <Column
                        title="Month"
                        dataIndex="month"
                        key="month"
                        render={month => dayjs(month).format('MMM YYYY')}
                      />
                      <Column
                        title="Total Rooms Available"
                        dataIndex={['totals', 'roomsAvail']}
                        key="roomsAvail"
                      />
                      <Column
                        title="Total Rooms Booked"
                        dataIndex={['totals', 'roomsBooked']}
                        key="roomsBooked"
                      />
                      <Column
                        title="Total Rooms Blocked"
                        dataIndex={['totals', 'roomsBlocked']}
                        key="roomsBlocked"
                      />
                      <Column
                        title="Total PAX"
                        dataIndex={['totals', 'roomsPAX']}
                        key="roomsPAX"
                      />
                      <Column
                        title="Total Guide Meals"
                        dataIndex={['totals', 'guideMeals']}
                        key="guideMeals"
                      />
                      <Column
                        title="Occupancy %"
                        dataIndex={['totals', 'occupancy']}
                        key="occupancy"
                        render={value =>
                          value != null ? `${value.toFixed(0)}%` : '-'
                        }
                      />
                    </StyledTable>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tab="Sales" key="Sales">
                <Row style={{ marginTop: '1em' }}>
                  <Col xs={24} lg={6}>
                    <h1
                      style={{
                        marginBottom: '0em',
                        fontSize: '22px',
                        fontWeight: 800,
                        fontFamily: 'Nunito',
                        marginTop: '0.3em'
                      }}
                    >
                      Sales Management
                    </h1>
                  </Col>
                  <Col xs={24} lg={18}>
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.6em',
                        justifyContent: this.props.isMobile
                          ? 'flex-start'
                          : 'flex-end',
                        marginTop: this.props.isMobile ? '0.75em' : 0
                      }}
                    >
                      {/* <Select
                        size="large"
                        defaultValue={this.state.siteSelected} // Bind selected values to state
                        showSearch

                        onChange={values => {
                          this.props.setSelectedSite(values);
                          this.setState({ siteSelected: values }, () => {
                            this.handleSearchName();
                          });
                        }}
                        style={{
                          width: this.props.isMobile ? '100%' : '12em'
                        }}
                        placeholder="Select Company"
                        optionFilterProp="children"
                      >
  
  
                        {this.props.sites.map(site => (
                          <Option key={site._id} value={site._id}>
                            {site.name}
                          </Option>
                        ))}
                      </Select> */}
                      <Select
                        size="large"
                        // mode="multiple"
                        allowClear
                        placeholder="Category"
                        value={this.state.selectedCategory} // Sync state to selected value
                        onChange={this.handleCategoryChange}
                        style={{
                          width: this.props.isMobile ? '100%' : '12em'
                        }}
                      >
                        {[
                          ...new Set(
                            this.props.sites.flatMap(
                              site => site.saleCategories || []
                            )
                          )
                        ].map(category => (
                          <Option key={category} value={category}>
                            {category}
                          </Option>
                        ))}
                      </Select>

                      {/* <DatePicker
                        picker="year"
                        size="large"
                        format="YYYY"
                        placeholder="Select Month"
                        onChange={this.handleYearChange}
                        defaultValue={this.state.selectedYear ? dayjs(this.state.selectedYear) : dayjs()}  // Automatically sets to the current month
                        style={{ marginRight: "1.2em", width: 140 }}
                        allowClear
                      /> */}
                      {/* <Search
                    size="large"
                    placeholder="Search Product"
                    allowClear
                    onSearch={this.handleSearchProduct}
                    enterButton
                    style={{ marginRight: '1.2em', width: '20em' }}
                    defaultValue={this.state.searchText}
                  /> */}
                      <Button
                        ref={this.ref}
                        type="primary"
                        onClick={this.onAddStock}
                        icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                        size="large"
                        style={{
                          flex: this.props.isMobile ? '1 1 auto' : undefined
                        }}
                      >
                        Add Sale
                      </Button>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: 'black',
                          marginTop: this.props.isMobile ? 0 : '0.3em',
                          marginLeft: this.props.isMobile ? 0 : '0.4em',
                          width: this.props.isMobile ? 44 : undefined,
                          minWidth: this.props.isMobile ? 44 : undefined
                        }}
                        onClick={() => this.exportSalesToExcel(groupedData)}
                      >
                        <DownloadOutlined />
                      </Button>
                      {/* <Button
                    size="large"
                    onClick={() => this.setState({ openSteps: true })}
                    style={{ marginLeft: '1em' }}
                  >
                    <InfoCircleFilled />
                  </Button> */}
                    </div>
                  </Col>

                  <Col span={24}>
                    <MobileTableHelp>
                      <strong>SWIPE</strong>
                      Swipe sideways for more columns. Tap + to open details.
                    </MobileTableHelp>
                    <StyledTable
                      bordered={false}
                      dataSource={groupedData}
                      rowKey="saleMonth"
                      style={{ marginTop: '1em' }}
                      pagination={false}
                      expandable={{
                        expandedRowRender: monthRecord => (
                          <StyledTable
                            bordered={false}
                            dataSource={Object.values(monthRecord.records)}
                            rowKey="saleDay"
                            pagination={false}
                            expandable={{
                              expandedRowRender: dayRecord => (
                                <StyledTableExpanded
                                  dataSource={dayRecord.records}
                                  pagination={false}
                                  rowKey={item => item._id}
                                  expandable={{
                                    expandedRowRender: record => {
                                      const {
                                        saleCategory,
                                        extraSales,
                                        saleRefund,
                                        saleComments
                                      } = record;
                                      if (!Array.isArray(saleCategory))
                                        return null;

                                      // ✅ Ensure category selection filters correctly
                                      const filteredExpandedData = saleCategory
                                        .map((category, index) => ({
                                          key: `${record._id}-${category}`,
                                          category,
                                          extraSales: extraSales?.[index] || 0,
                                          saleRefund: saleRefund?.[index] || 0,
                                          saleComments:
                                            saleComments?.[index] ||
                                            'No Comments'
                                        }))
                                        .filter(
                                          item =>
                                            !this.state.selectedCategory ||
                                            item.category ===
                                              this.state.selectedCategory
                                        ); // ✅ Filter by selected category

                                      // ✅ If no data after filtering, return nothing
                                      if (filteredExpandedData.length === 0)
                                        return null;

                                      return (
                                        <StyledTable
                                          dataSource={filteredExpandedData}
                                          pagination={false}
                                          rowKey="key"
                                          columns={[
                                            {
                                              title: 'Category',
                                              dataIndex: 'category',
                                              key: 'category'
                                            },
                                            {
                                              title: 'Extra Sales',
                                              dataIndex: 'extraSales',
                                              key: 'extraSales',
                                              render: text => {
                                                const companyCurrency =
                                                  this.props.sites.find(
                                                    site =>
                                                      site._id ===
                                                      this.state.siteSelected
                                                  )?.companyCurrency || 'R';

                                                return `${companyCurrency} ${new Intl.NumberFormat(
                                                  'en-US',
                                                  {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  }
                                                ).format(Number(text) || 0)}`;
                                              }
                                            },
                                            {
                                              title: 'Complimentary / Refund',
                                              dataIndex: 'saleRefund',
                                              key: 'saleRefund',
                                              render: text => {
                                                const companyCurrency =
                                                  this.props.sites.find(
                                                    site =>
                                                      site._id ===
                                                      this.state.siteSelected
                                                  )?.companyCurrency || 'R';

                                                // Format the number with thousand separators and two decimals
                                                const formattedValue = new Intl.NumberFormat(
                                                  'en-US',
                                                  {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  }
                                                ).format(Number(text) || 0);

                                                return text > 0 ? (
                                                  <Tag color="red">{`${companyCurrency} ${formattedValue}`}</Tag>
                                                ) : (
                                                  'N/A'
                                                );
                                              }
                                            },
                                            {
                                              title: 'Comments',
                                              dataIndex: 'saleComments',
                                              key: 'saleComments'
                                            }
                                          ]}
                                        />
                                      );
                                    }
                                  }}
                                  columns={[
                                    {
                                      title: 'Booking Number',
                                      dataIndex: 'bookingNr',
                                      key: 'bookingNr'
                                      // render: (text) => {
                                      //   if (Array.isArray(text)) {
                                      //     return text.includes(this.state.selectedCategory) ? this.state.selectedCategory : text.join(", ");
                                      //   }
                                      //   return text;
                                      // },
                                    },
                                    // {
                                    //   title: "Category",
                                    //   dataIndex: "saleCategory",
                                    //   key: "saleCategory",
                                    //   render: (text) => {
                                    //     if (Array.isArray(text)) {
                                    //       return text.includes(this.state.selectedCategory) ? this.state.selectedCategory : text.join(", ");
                                    //     }
                                    //     return text;
                                    //   },
                                    // },
                                    {
                                      title: 'Extra Sales',
                                      dataIndex: 'extraSales',
                                      key: 'extraSales',
                                      render: (text, record) => {
                                        const selectedCategory = this.state
                                          .selectedCategory;
                                        let totalExtraSales = 0;

                                        // ✅ If no category is selected, sum ALL values
                                        if (!selectedCategory) {
                                          totalExtraSales = Array.isArray(
                                            record.extraSales
                                          )
                                            ? record.extraSales.reduce(
                                                (sum, value) =>
                                                  sum + (Number(value) || 0),
                                                0
                                              )
                                            : Number(record.extraSales) || 0;
                                        }
                                        // ✅ If a category is selected, filter accordingly
                                        else if (
                                          Array.isArray(record.extraSales) &&
                                          Array.isArray(record.saleCategory)
                                        ) {
                                          totalExtraSales = record.saleCategory.reduce(
                                            (sum, category, index) => {
                                              return category ===
                                                selectedCategory
                                                ? sum +
                                                    (Number(
                                                      record.extraSales[index]
                                                    ) || 0)
                                                : sum;
                                            },
                                            0
                                          );
                                        } else {
                                          totalExtraSales =
                                            Number(record.extraSales) || 0;
                                        }

                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly
                                        return `${companyCurrency} ${totalExtraSales.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },
                                    {
                                      title: 'Cash',
                                      dataIndex: 'saleCash',
                                      key: 'saleCash',
                                      render: text => {
                                        const cashValue = Array.isArray(text)
                                          ? text.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(text) || 0;
                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly
                                        return `${companyCurrency} ${cashValue.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },
                                    {
                                      title: 'Card',
                                      dataIndex: 'saleCard',
                                      key: 'saleCard',
                                      render: text => {
                                        const cardValue = Array.isArray(text)
                                          ? text.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(text) || 0;
                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly
                                        return `${companyCurrency} ${cardValue.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },
                                    {
                                      title: 'Complimentary / Refund',
                                      dataIndex: 'saleRefund',
                                      key: 'saleRefund',
                                      render: (text, record) => {
                                        const selectedCategory = this.state
                                          .selectedCategory;
                                        let totalRefunds = 0;

                                        // ✅ If no category is selected, sum ALL values
                                        if (!selectedCategory) {
                                          totalRefunds = Array.isArray(
                                            record.saleRefund
                                          )
                                            ? record.saleRefund.reduce(
                                                (sum, value) =>
                                                  sum + (Number(value) || 0),
                                                0
                                              )
                                            : Number(record.saleRefund) || 0;
                                        }
                                        // ✅ If a category is selected, filter accordingly
                                        else if (
                                          Array.isArray(record.saleRefund) &&
                                          Array.isArray(record.saleCategory)
                                        ) {
                                          totalRefunds = record.saleCategory.reduce(
                                            (sum, category, index) => {
                                              return category ===
                                                selectedCategory
                                                ? sum +
                                                    (Number(
                                                      record.saleRefund[index]
                                                    ) || 0)
                                                : sum;
                                            },
                                            0
                                          );
                                        } else {
                                          totalRefunds =
                                            Number(record.saleRefund) || 0;
                                        }

                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly and apply red tag only if refund exists
                                        return totalRefunds > 0 ? (
                                          <Tag color="red">{`${companyCurrency} ${totalRefunds.toLocaleString(
                                            'en-US',
                                            {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            }
                                          )}`}</Tag>
                                        ) : null;
                                      }
                                    },

                                    {
                                      title: 'Bednights',
                                      dataIndex: 'saleBednights',
                                      key: 'saleBednights',
                                      render: text => {
                                        const bednightsValue = Array.isArray(
                                          text
                                        )
                                          ? text.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(text) || 0;

                                        return bednightsValue || 0;
                                      }
                                    },
                                    {
                                      title: 'Balance',
                                      dataIndex: 'balance',
                                      key: 'balance',
                                      render: (text, record) => {
                                        const selectedCategory = this.state
                                          .selectedCategory;
                                        let totalExtraSales = 0;
                                        let cashValue = 0;
                                        let cardValue = 0;
                                        let refundValue = 0;

                                        // ✅ Calculate Total Extra Sales
                                        if (!selectedCategory) {
                                          totalExtraSales = Array.isArray(
                                            record.extraSales
                                          )
                                            ? record.extraSales.reduce(
                                                (sum, value) =>
                                                  sum + (Number(value) || 0),
                                                0
                                              )
                                            : Number(record.extraSales) || 0;
                                        } else if (
                                          Array.isArray(record.extraSales) &&
                                          Array.isArray(record.saleCategory)
                                        ) {
                                          totalExtraSales = record.saleCategory.reduce(
                                            (sum, category, index) => {
                                              return category ===
                                                selectedCategory
                                                ? sum +
                                                    (Number(
                                                      record.extraSales[index]
                                                    ) || 0)
                                                : sum;
                                            },
                                            0
                                          );
                                        } else {
                                          totalExtraSales =
                                            Number(record.extraSales) || 0;
                                        }

                                        // ✅ Calculate Total Cash
                                        cashValue = Array.isArray(
                                          record.saleCash
                                        )
                                          ? record.saleCash.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(record.saleCash) || 0;

                                        // ✅ Calculate Total Card
                                        cardValue = Array.isArray(
                                          record.saleCard
                                        )
                                          ? record.saleCard.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(record.saleCard) || 0;

                                        refundValue = Array.isArray(
                                          record.saleRefund
                                        )
                                          ? record.saleRefund.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(record.saleRefund) || 0;

                                        // ✅ Compute Balance
                                        const balance =
                                          totalExtraSales -
                                          (cashValue + cardValue + refundValue);

                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format as Currency
                                        return `${companyCurrency} ${balance.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },

                                    {
                                      title: 'Actions',
                                      fixed: 'right',
                                      width: 96,
                                      render: (text, record) => (
                                        <span>
                                          <Tooltip placement="top" title="Edit">
                                            <EditFilled
                                              style={{
                                                backgroundColor: '#80CE90',
                                                color: 'white',
                                                padding: '0.5em',
                                                borderRadius: '3em'
                                              }}
                                              onClick={e =>
                                                this.handleEditStock(record)
                                              }
                                            />
                                          </Tooltip>
                                          <Divider type="vertical" />
                                          <Tooltip
                                            placement="top"
                                            title="Delete"
                                          >
                                            <DeleteFilled
                                              style={{
                                                backgroundColor: 'crimson',
                                                color: 'white',
                                                padding: '0.5em',
                                                borderRadius: '3em'
                                              }}
                                              onClick={e => {
                                                e.stopPropagation(); // Prevent row click event
                                                this.setState({
                                                  deleteVisible: true,
                                                  deleteStock: record
                                                });
                                              }}
                                            />
                                          </Tooltip>
                                        </span>
                                      )
                                    }
                                  ]}
                                />
                              )
                            }}
                            columns={[
                              {
                                title: 'Day',
                                dataIndex: 'saleDay',
                                key: 'saleDay',
                                render: text => dayjs(text).format('DD-MM-YYYY')
                              },
                              {
                                title: 'Extra Sales',
                                dataIndex: ['totals', 'extraSales'],
                                key: 'extraSales',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },
                              {
                                title: 'Cash',
                                dataIndex: ['totals', 'cashSales'],
                                key: 'cashSales',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },

                              {
                                title: 'Card',
                                dataIndex: ['totals', 'cardSales'],
                                key: 'cardSales',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },

                              {
                                title: 'Complimentary / Refund',
                                dataIndex: ['totals', 'refunds'],
                                key: 'refunds',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  // Format the number with thousand separators and two decimals
                                  const formattedValue = new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0);

                                  return text > 0 ? (
                                    <Tag color="red">{`${companyCurrency} ${formattedValue}`}</Tag>
                                  ) : (
                                    'N/A'
                                  );
                                }
                              },
                              {
                                title: 'Bednights',
                                dataIndex: ['totals', 'bednights'],
                                key: 'bednights',
                                render: text => text || 0
                              },
                              {
                                title: 'Balance',
                                dataIndex: ['totals', 'totalIncome'],
                                key: 'totalIncome',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },
                              {
                                title: 'Value per Sale',
                                key: 'valuePerSale',
                                render: record => {
                                  const extraSales =
                                    Number(record?.totals?.extraSales) || 0;
                                  const bednights =
                                    Number(record?.totals?.bednights) || 0;
                                  const valuePerSale =
                                    bednights > 0 ? extraSales / bednights : 0;

                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(valuePerSale)}`;
                                }
                              }
                            ]}
                          />
                        )
                      }}
                      columns={[
                        {
                          title: 'Month',
                          dataIndex: 'saleMonth',
                          key: 'saleMonth',
                          render: text => dayjs(text).format('MMM YYYY')
                        },
                        {
                          title: 'Extra Sales',
                          dataIndex: ['totals', 'extraSales'],
                          key: 'extraSales',
                          render: (extraSales, record) => {
                            const currency =
                              this.props.sites.find(
                                s => s._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            const toNum = v => Number(v) || 0;
                            const fmt = v =>
                              `${currency} ${new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }).format(v)}`;

                            const extra = toNum(extraSales);
                            const cash = toNum(record?.totals?.cashSales);
                            const card = toNum(record?.totals?.cardSales);
                            // const combined = extra;
                            const combined = cash + card; // <-- add Balance to Extra Sales

                            return fmt(combined);
                          }
                        },
                        {
                          title: 'Cash',
                          dataIndex: ['totals', 'cashSales'],
                          key: 'cashSales',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        },
                        {
                          title: 'Card',
                          dataIndex: ['totals', 'cardSales'],
                          key: 'cardSales',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        },

                        {
                          title: 'Complimentary / Refund',
                          dataIndex: ['totals', 'refunds'],
                          key: 'refunds',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            // Format the number with thousand separators and two decimals
                            const formattedValue = new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0);

                            return text > 0 ? (
                              <Tag color="red">{`${companyCurrency} ${formattedValue}`}</Tag>
                            ) : (
                              'N/A'
                            );
                          }
                        },
                        {
                          title: 'Bednights',
                          dataIndex: ['totals', 'bednights'],
                          key: 'bednights',
                          render: text => text || 0
                        },
                        {
                          title: 'Balance',
                          dataIndex: ['totals', 'totalIncome'],
                          key: 'totalIncome',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        }
                      ]}
                    />
                  </Col>
                </Row>
              </TabPane>

              <TabPane tab="Variable Cost" key="Variable Cost">
                <Row style={{ marginTop: '1em' }}>
                  <Col xs={24} lg={6}>
                    <h1
                      style={{
                        marginBottom: '0em',
                        fontSize: '22px',
                        fontWeight: 800,
                        fontFamily: 'Nunito',
                        marginTop: '0.3em'
                      }}
                    >
                      Cost Management
                    </h1>
                  </Col>
                  <Col xs={24} lg={18}>
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.6em',
                        justifyContent: this.props.isMobile
                          ? 'flex-start'
                          : 'flex-end',
                        marginTop: this.props.isMobile ? '0.75em' : 0
                      }}
                    >
                      {/* <Select
                        size="large"
                        defaultValue={this.state.siteSelected} // Bind selected values to state
                        showSearch

                        onChange={values => {
                          this.props.setSelectedSite(values);
                          this.setState({ siteSelected: values }, () => {
                            this.handleSearchName();
                          });
                        }}
                        style={{
                          width: this.props.isMobile ? '100%' : '12em'
                        }}
                        placeholder="Select Company"
                        optionFilterProp="children"
                      >

                        {this.props.sites.map(site => (
                          <Option key={site._id} value={site._id}>
                            {site.name}
                          </Option>
                        ))}
                      </Select> */}
                      <Select
                        size="large"
                        style={{
                          width: this.props.isMobile ? '100%' : '12em'
                        }}
                        placeholder="Category"
                        onChange={this.handleCategoryCostChange}
                        allowClear
                      >
                        {/* Dynamically create options based on unique categories */}
                        {/* {[...new Set(groupedData.map(item => item.saleCategory))].map(category => (
                          <Option key={category} value={category}>
                            {category}
                          </Option>
                        ))} */}
                        {/* Ensure saleCategories is an array and flatten if needed */}
                        {(this.state.inventoryCostSiteId
                          ? [
                              ...new Set(
                                (this.state.stockRequests || [])
                                  .map(r => (r.masterAllocation || '').trim())
                                  .filter(Boolean)
                              )
                            ].sort((a, b) =>
                              a.localeCompare(b, undefined, {
                                sensitivity: 'base'
                              })
                            )
                          : [
                              ...new Set(
                                (this.props.sites || []).flatMap(
                                  site => site.costCategories || []
                                )
                              )
                            ].sort((a, b) =>
                              a.localeCompare(b, undefined, {
                                sensitivity: 'base'
                              })
                            )
                        ).map(category => (
                          <Option key={category} value={category}>
                            {category}
                          </Option>
                        ))}
                      </Select>
                      {/* <DatePicker
                        picker="year"
                        size="large"
                        format="YYYY"
                        placeholder="Select Month"
                        onChange={this.handleYearChange}
                        defaultValue={this.state.selectedYear ? dayjs(this.state.selectedYear) : dayjs()}  // Automatically sets to the current month
                        style={{ marginRight: "1.2em", width: 140 }}
                        allowClear
                      /> */}
                      {!this.state.inventoryCostSiteId && (
                        <Button
                          ref={this.ref}
                          type="primary"
                          onClick={this.onAddStockCost}
                          icon={
                            <PlusCircleFilled style={{ fontSize: '110%' }} />
                          }
                          size="large"
                          style={{
                            flex: this.props.isMobile
                              ? '1 1 auto'
                              : undefined
                          }}
                        >
                          Add Cost
                        </Button>
                      )}
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: 'black',
                          marginTop: this.props.isMobile ? 0 : '0.3em',
                          marginLeft: this.props.isMobile ? 0 : '0.4em',
                          width: this.props.isMobile ? 44 : undefined,
                          minWidth: this.props.isMobile ? 44 : undefined
                        }}
                        onClick={() => {
                          if (this.state.inventoryCostSiteId) {
                            this.exportCostRequestsToExcel();
                          } else {
                            this.exportCostToExcel(groupedDataCost);
                          }
                        }}
                      >
                        <DownloadOutlined />
                      </Button>
                    </div>
                  </Col>

                  <Col span={24}>
                    <MobileTableHelp>
                      <strong>SWIPE</strong>
                      Swipe sideways for more columns. Tap + to open details.
                    </MobileTableHelp>
                    {this.state.inventoryCostSiteId ? (
                      // ✅ NEW: linked inventory costs (from requests)
                      <StyledTable
                        className="compact-mobile-table"
                        style={{ marginTop: '1em' }}
                        rowKey="_id"
                        dataSource={monthData}
                        pagination={false}
                        columns={[
                          {
                            title: 'Month',
                            dataIndex: 'monthLabel',
                            key: 'monthLabel'
                          },
                          {
                            title: 'Total (Month)',
                            dataIndex: 'monthTotal',
                            key: 'monthTotal',
                            align: 'right',
                            render: (v, rec) =>
                              `${rec.currency} ${(
                                Number(v) || 0
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}`
                          }
                        ]}
                        expandable={{
                          rowExpandable: rec =>
                            Array.isArray(rec.records) &&
                            rec.records.length > 0,
                          expandedRowRender: monthRec => (
                            <StyledTable
                              rowKey="_id"
                              dataSource={monthRec.records || []} // ✅ days
                              pagination={false}
                              columns={[
                                {
                                  title: 'Day',
                                  dataIndex: 'dayLabel',
                                  key: 'dayLabel'
                                },

                                {
                                  title: 'Bednights',
                                  key: 'dayBednights',
                                  align: 'right',
                                  render: (_, rec) => {
                                    const roomRecord = this.state.stockData.find(
                                      item =>
                                        item.roomsDate &&
                                        dayjs(item.roomsDate).format(
                                          'YYYY-MM-DD'
                                        ) === rec.dayKey &&
                                        item.access === this.state.siteSelected
                                    );
                                    return roomRecord
                                      ? Number(roomRecord.roomsPAX) || 0
                                      : '-';
                                  }
                                },
                                {
                                  title: 'Staff On Site',
                                  key: 'dayStaff',
                                  align: 'right',
                                  render: (_, rec) => {
                                    const roomRecord = this.state.stockData.find(
                                      item =>
                                        item.roomsDate &&
                                        dayjs(item.roomsDate).format(
                                          'YYYY-MM-DD'
                                        ) === rec.dayKey &&
                                        item.access === this.state.siteSelected
                                    );
                                    return roomRecord
                                      ? Number(roomRecord.staffOnSite) || 0
                                      : '-';
                                  }
                                },
                                {
                                  title: 'Total (Day)',
                                  dataIndex: 'dayTotal',
                                  key: 'dayTotal',
                                  align: 'right',
                                  render: (v, rec) =>
                                    `${rec.currency} ${(
                                      Number(v) || 0
                                    ).toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}`
                                },
                                {
                                  title: 'MTD P/Bednight',
                                  key: 'dayPerUnit',
                                  align: 'right',
                                  render: (_, rec) => {
                                    const roomRecord = this.state.stockData.find(
                                      item =>
                                        item.roomsDate &&
                                        dayjs(item.roomsDate).format(
                                          'YYYY-MM-DD'
                                        ) === rec.dayKey &&
                                        item.access === this.state.siteSelected
                                    );
                                    const bednights =
                                      Number(roomRecord?.roomsPAX) || 0;
                                    const staffOnSite =
                                      Number(roomRecord?.staffOnSite) || 0;
                                    let canteenCost = 0;
                                    let otherCost = 0;
                                    (rec.records || []).forEach(item => {
                                      const cost = Number(item.totalCosts) || 0;
                                      if (
                                        item.masterAllocation ===
                                        'Staff Canteen Cost'
                                      ) {
                                        canteenCost += cost;
                                      } else {
                                        otherCost += cost;
                                      }
                                    });
                                    const parts = [];
                                    if (otherCost > 0 && bednights > 0) {
                                      const conv = this.convertToTargetCurrency(
                                        otherCost / bednights,
                                        inventorySite,
                                        selectedSite
                                      );
                                      parts.push(
                                        `${
                                          conv.currency
                                        } ${conv.value.toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )} `
                                      );
                                    }
                                    // if (canteenCost > 0 && staffOnSite > 0) {
                                    //   const conv = this.convertToTargetCurrency(canteenCost / staffOnSite, inventorySite, selectedSite);
                                    //   parts.push(`${conv.currency} ${conv.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} P/Staff`);
                                    // }
                                    return parts.length > 0
                                      ? parts.join(' | ')
                                      : '-';
                                  }
                                }
                              ]}
                              expandable={{
                                rowExpandable: rec =>
                                  Array.isArray(rec.records) &&
                                  rec.records.length > 0,
                                expandedRowRender: dayRec => {
                                  // Group the day's usage lines by usage so each
                                  // row is a single Usage (Usage #, Master / Sub
                                  // Allocation, total) — expand a row to see the
                                  // individual item details, instead of listing
                                  // every line for the whole day.
                                  const usageMap = {};
                                  (dayRec.records || []).forEach(r => {
                                    const key = r.usageId || r._id;
                                    if (!usageMap[key]) {
                                      usageMap[key] = {
                                        _id: key,
                                        usageNumber: r.usageNumber || '',
                                        masterAllocation:
                                          r.masterAllocation || '',
                                        subAllocation: r.subAllocation || '',
                                        requestedFrom: r.requestedFrom || '',
                                        requestDate: r.requestDate,
                                        total: 0,
                                        vat: 0,
                                        lines: []
                                      };
                                    }
                                    usageMap[key].total +=
                                      Number(r.totalCosts) || 0;
                                    usageMap[key].vat += r.vatable
                                      ? Number(r.vatAmount) || 0
                                      : 0;
                                    usageMap[key].lines.push(r);
                                  });
                                  const usageRows = Object.values(
                                    usageMap
                                  ).sort(
                                    (a, b) =>
                                      new Date(a.requestDate) -
                                      new Date(b.requestDate)
                                  );
                                  return (
                                    <StyledTable
                                      rowKey="_id"
                                      dataSource={usageRows} // ✅ one row per usage
                                      pagination={{ pageSize: 50 }}
                                      columns={[
                                        {
                                          title: 'Usage #',
                                          dataIndex: 'usageNumber',
                                          key: 'usageNumber',
                                          render: t => t || '-'
                                        },
                                        {
                                          title: 'Master Allocation',
                                          dataIndex: 'masterAllocation',
                                          key: 'masterAllocation',
                                          render: t => t || 'Uncategorized'
                                        },
                                        {
                                          title: 'Sub Allocation',
                                          dataIndex: 'subAllocation',
                                          key: 'subAllocation',
                                          render: t => t || '-'
                                        },
                                        {
                                          title: 'Items',
                                          key: 'lineCount',
                                          align: 'right',
                                          render: (_, rec) =>
                                            (rec.lines || []).length
                                        },
                                        {
                                          title: 'Time',
                                          dataIndex: 'requestDate',
                                          key: 'requestDate',
                                          render: d =>
                                            d ? dayjs(d).format('HH:mm') : '-'
                                        },
                                        {
                                          // VAT on this usage: the sum of its
                                          // VAT-ticked lines. Blank when none
                                          // are ticked. Total Cost already
                                          // includes it.
                                          title: 'VAT',
                                          dataIndex: 'vat',
                                          key: 'vat',
                                          align: 'right',
                                          render: v => {
                                            if (!(Number(v) > 0)) return '-';
                                            const conv = this.convertToTargetCurrency(
                                              Number(v) || 0,
                                              inventorySite,
                                              selectedSite
                                            );
                                            return `${
                                              conv.currency
                                            } ${conv.value.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                              }
                                            )}`;
                                          }
                                        },
                                        {
                                          title: 'Total Cost',
                                          dataIndex: 'total',
                                          key: 'total',
                                          align: 'right',
                                          render: v => {
                                            const conv = this.convertToTargetCurrency(
                                              Number(v) || 0,
                                              inventorySite,
                                              selectedSite
                                            );
                                            return `${
                                              conv.currency
                                            } ${conv.value.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                              }
                                            )}`;
                                          }
                                        },
                                        {
                                          title: 'MTD P/Bednight',
                                          key: 'usagePerUnit',
                                          align: 'right',
                                          render: (_, rec) => {
                                            const requestDay = dayjs(
                                              rec.requestDate
                                            ).format('YYYY-MM-DD');
                                            const roomRecord = this.state.stockData.find(
                                              item =>
                                                item.roomsDate &&
                                                dayjs(item.roomsDate).format(
                                                  'YYYY-MM-DD'
                                                ) === requestDay &&
                                                item.access ===
                                                  this.state.siteSelected
                                            );
                                            const isCanteen =
                                              rec.masterAllocation ===
                                              'Staff Canteen Cost';
                                            const divisor = isCanteen
                                              ? Number(roomRecord?.staffOnSite) ||
                                                0
                                              : Number(roomRecord?.roomsPAX) ||
                                                0;
                                            const cost = Number(rec.total) || 0;
                                            const perUnit =
                                              divisor > 0 ? cost / divisor : 0;
                                            const conv = this.convertToTargetCurrency(
                                              perUnit,
                                              inventorySite,
                                              selectedSite
                                            );
                                            const label = isCanteen
                                              ? ' P/Staff'
                                              : ' ';
                                            return `${
                                              conv.currency
                                            } ${conv.value.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                              }
                                            )}${label}`;
                                          }
                                        }
                                      ]}
                                      expandable={{
                                        rowExpandable: rec =>
                                          Array.isArray(rec.lines) &&
                                          rec.lines.length > 0,
                                        expandedRowRender: usageRec => (
                                          <StyledTable
                                            rowKey="_id"
                                            dataSource={usageRec.lines || []} // ✅ items
                                            pagination={false}
                                            columns={[
                                              {
                                                title: 'Item',
                                                dataIndex: 'itemName',
                                                key: 'itemName',
                                                render: t => t || '-'
                                              },
                                              {
                                                title: 'Requested From',
                                                dataIndex: 'requestedFrom',
                                                key: 'requestedFrom',
                                                render: t => t || '-'
                                              },
                                              {
                                                title: 'Unit Cost',
                                                dataIndex: 'costPerUnit',
                                                key: 'costPerUnit',
                                                align: 'right',
                                                render: v => {
                                                  const conv = this.convertToTargetCurrency(
                                                    Number(v) || 0,
                                                    inventorySite,
                                                    selectedSite
                                                  );
                                                  return `${
                                                    conv.currency
                                                  } ${conv.value.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2
                                                    }
                                                  )}`;
                                                }
                                              },
                                              {
                                                // Only items ticked for VAT on
                                                // the POS usage carry a value.
                                                // Their Unit Cost and Total
                                                // Cost already include it.
                                                title: 'VAT',
                                                dataIndex: 'vatAmount',
                                                key: 'vatAmount',
                                                align: 'right',
                                                render: (v, rec) => {
                                                  if (!rec.vatable || !(Number(v) > 0)) return '-';
                                                  const conv = this.convertToTargetCurrency(
                                                    Number(v) || 0,
                                                    inventorySite,
                                                    selectedSite
                                                  );
                                                  const rate = Number(rec.vatRate) || 0;
                                                  return `${
                                                    conv.currency
                                                  } ${conv.value.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2
                                                    }
                                                  )}${rate ? ` (${rate}%)` : ''}`;
                                                }
                                              },
                                              {
                                                title: 'Total Cost',
                                                dataIndex: 'totalCosts',
                                                key: 'totalCosts',
                                                align: 'right',
                                                render: v => {
                                                  const conv = this.convertToTargetCurrency(
                                                    Number(v) || 0,
                                                    inventorySite,
                                                    selectedSite
                                                  );
                                                  return `${
                                                    conv.currency
                                                  } ${conv.value.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2
                                                    }
                                                  )}`;
                                                }
                                              }
                                            ]}
                                          />
                                        )
                                      }}
                                    />
                                  );
                                }
                              }}
                            />
                          )
                        }}
                      />
                    ) : (
                      // ✅ ORIGINAL: your current Cost Management table
                      <StyledTable
                        bordered={false}
                        dataSource={groupedDataCost}
                        rowKey="costMonth"
                        style={{ marginTop: '1em' }}
                        pagination={false}
                        expandable={{
                          expandedRowRender: monthRecord => (
                            <StyledTable
                              bordered={false}
                              dataSource={Object.values(monthRecord.records)}
                              rowKey="costDay"
                              pagination={false}
                              expandable={{
                                expandedRowRender: dayRecord => {
                                  console.log(
                                    '✅ Debugging `dayRecord.records` structure:',
                                    dayRecord.records
                                  );

                                  if (
                                    !dayRecord.records ||
                                    dayRecord.records.length === 0
                                  )
                                    return null;

                                  // 🟡 Ensure `_id` exists in each record
                                  dayRecord.records.forEach(record => {
                                    console.log(
                                      `🟡 Checking record: ${
                                        record._id
                                      } | Categories: ${record.costCategory}`
                                    );
                                  });

                                  const categoryData = dayRecord.records.flatMap(
                                    record =>
                                      Array.isArray(record.costCategory)
                                        ? record.costCategory.map(
                                            (category, index) => ({
                                              key: `${record._id}-${category}`,
                                              category,
                                              costPrice: Array.isArray(
                                                record.costPrice
                                              )
                                                ? record.costPrice[index]
                                                : record.costPrice,
                                              costPerPerson: Array.isArray(
                                                record.costPerPerson
                                              )
                                                ? record.costPerPerson[index]
                                                : record.costPerPerson,
                                              costComments: Array.isArray(
                                                record.costComments
                                              )
                                                ? record.costComments[index]
                                                : record.costComments,
                                              dailyBudget: Array.isArray(
                                                record.dailyBudget
                                              )
                                                ? record.dailyBudget[index]
                                                : record.dailyBudget
                                            })
                                          )
                                        : []
                                  );

                                  if (categoryData.length === 0)
                                    return (
                                      <p style={{ paddingLeft: '1em' }}>
                                        No categories available
                                      </p>
                                    );

                                  return (
                                    <StyledTable
                                      dataSource={categoryData}
                                      pagination={false}
                                      rowKey="key"
                                      columns={[
                                        {
                                          title: 'Category',
                                          dataIndex: 'category',
                                          key: 'category'
                                        },
                                        {
                                          title: 'Cost P/Person',
                                          dataIndex: 'costPerPerson',
                                          key: 'costPerPerson',
                                          render: (text, record) => {
                                            const selectedCategory = this.state
                                              .selectedCategory;
                                            let totalCostPerPerson = 0;

                                            // ✅ If no category is selected, sum ALL values
                                            if (!selectedCategory) {
                                              totalCostPerPerson = Array.isArray(
                                                record.costPerPerson
                                              )
                                                ? record.costPerPerson.reduce(
                                                    (sum, value) =>
                                                      sum +
                                                      (Number(value) || 0),
                                                    0
                                                  )
                                                : Number(
                                                    record.costPerPerson
                                                  ) || 0;
                                            }
                                            // ✅ If a category is selected, filter accordingly
                                            else if (
                                              Array.isArray(
                                                record.costPerPerson
                                              ) &&
                                              Array.isArray(record.costCategory)
                                            ) {
                                              totalCostPerPerson = record.costCategory.reduce(
                                                (sum, category, index) => {
                                                  return category ===
                                                    selectedCategory
                                                    ? sum +
                                                        (Number(
                                                          record.costPerPerson[
                                                            index
                                                          ]
                                                        ) || 0)
                                                    : sum;
                                                },
                                                0
                                              );
                                            } else {
                                              totalCostPerPerson =
                                                Number(record.costPerPerson) ||
                                                0;
                                            }

                                            const companyCurrency =
                                              this.props.sites.find(
                                                site =>
                                                  site._id ===
                                                  this.state.siteSelected
                                              )?.companyCurrency || 'R';

                                            // ✅ Format the number properly
                                            return `${companyCurrency} ${totalCostPerPerson.toLocaleString(
                                              'en-US',
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                              }
                                            )}`;
                                          }
                                        },
                                        {
                                          title: 'Cost',
                                          dataIndex: 'costPrice',
                                          key: 'costPrice',
                                          render: (text, record) => {
                                            // compute totalCost as before…
                                            const selectedCategory = this.state
                                              .selectedCategory;
                                            let totalCost = 0;
                                            if (!selectedCategory) {
                                              totalCost = Array.isArray(
                                                record.costPrice
                                              )
                                                ? record.costPrice.reduce(
                                                    (sum, v) =>
                                                      sum + (Number(v) || 0),
                                                    0
                                                  )
                                                : Number(record.costPrice) || 0;
                                            } else if (
                                              Array.isArray(record.costPrice) &&
                                              Array.isArray(record.costCategory)
                                            ) {
                                              totalCost = record.costCategory.reduce(
                                                (sum, category, idx) =>
                                                  category === selectedCategory
                                                    ? sum +
                                                      (Number(
                                                        record.costPrice[idx]
                                                      ) || 0)
                                                    : sum,
                                                0
                                              );
                                            } else {
                                              totalCost =
                                                Number(record.costPrice) || 0;
                                            }

                                            const companyCurrency =
                                              this.props.sites.find(
                                                s =>
                                                  s._id ===
                                                  this.state.siteSelected
                                              )?.companyCurrency || 'R';

                                            const formatted = new Intl.NumberFormat(
                                              'en-US',
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                                useGrouping: true
                                              }
                                            ).format(totalCost);

                                            const budgetForThisCategory =
                                              Number(record.dailyBudget) || 0;

                                            return (
                                              <span
                                                style={{
                                                  color:
                                                    totalCost >
                                                    budgetForThisCategory
                                                      ? 'red'
                                                      : undefined
                                                }}
                                              >
                                                {companyCurrency} {formatted}
                                              </span>
                                            );
                                          }
                                        },
                                        {
                                          title: 'Daily Budget',
                                          dataIndex: 'dailyBudget',
                                          key: 'dailyBudget',
                                          render: text => {
                                            if (text == null) return '';
                                            const curr =
                                              this.props.sites.find(
                                                s =>
                                                  s._id ===
                                                  this.state.siteSelected
                                              )?.companyCurrency || 'R';
                                            return `${curr} ${Number(
                                              text
                                            ).toLocaleString('en-US', {
                                              useGrouping: true, // turn on thousands separators
                                              minimumFractionDigits: 2, // always show 2 decimals
                                              maximumFractionDigits: 2
                                            })}`;
                                          }
                                        },

                                        {
                                          title: 'Comments',
                                          dataIndex: 'costComments',
                                          key: 'costComments',
                                          render: text => {
                                            if (!text) return '';

                                            const truncatedText =
                                              text.length > 60
                                                ? `${text.substring(0, 60)}...`
                                                : text;

                                            return text.length > 60 ? (
                                              <Tooltip title={text}>
                                                <span>{truncatedText}</span>
                                              </Tooltip>
                                            ) : (
                                              <span>{text}</span>
                                            );
                                          }
                                        }
                                      ]}
                                    />
                                  );
                                }
                              }}
                              columns={[
                                {
                                  title: 'Day',
                                  dataIndex: 'costDay',
                                  key: 'costDay',
                                  render: text =>
                                    dayjs(text).format('DD-MM-YYYY')
                                },

                                {
                                  title: 'Rooms Available',
                                  dataIndex: ['totals', 'roomsAvail'],
                                  key: 'roomsAvail'
                                },
                                {
                                  title: 'Rooms Booked',
                                  dataIndex: ['totals', 'rooms'],
                                  key: 'rooms'
                                },
                                {
                                  title: 'Occupancy %',
                                  dataIndex: ['totals', 'occupancy'],
                                  render: text => {
                                    const occupancyValue = Number(text) || 0; // ✅ Ensure a valid number
                                    return `${occupancyValue.toFixed(0)}%`; // ✅ Now `toFixed()` will work
                                  }
                                },
                                {
                                  title: 'PAX',
                                  dataIndex: ['totals', 'pax'],
                                  key: 'pax'
                                },

                                {
                                  title: 'Cost P/Person',
                                  dataIndex: ['totals', 'costPerPerson'],
                                  key: 'costPerPerson',
                                  render: text => {
                                    const companyCurrency =
                                      this.props.sites.find(
                                        site =>
                                          site._id === this.state.siteSelected
                                      )?.companyCurrency || 'R';

                                    return `${companyCurrency} ${new Intl.NumberFormat(
                                      'en-US',
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      }
                                    ).format(Number(text) || 0)}`;
                                  }
                                },
                                {
                                  title: 'Total Cost',
                                  dataIndex: ['totals', 'totalCost'],
                                  key: 'totalCost',
                                  render: (text, dayRecord) => {
                                    // parse out your numbers
                                    const totalCost = Number(text) || 0;
                                    const sumDailyBudgets = (
                                      dayRecord.records || []
                                    ).reduce((sum, rec) => {
                                      if (Array.isArray(rec.dailyBudget)) {
                                        return (
                                          sum +
                                          rec.dailyBudget.reduce(
                                            (s, v) => s + (Number(v) || 0),
                                            0
                                          )
                                        );
                                      }
                                      return (
                                        sum + (Number(rec.dailyBudget) || 0)
                                      );
                                    }, 0);

                                    // format for display
                                    const companyCurrency =
                                      this.props.sites.find(
                                        site =>
                                          site._id === this.state.siteSelected
                                      )?.companyCurrency || 'R';

                                    const formattedCost = new Intl.NumberFormat(
                                      'en-US',
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                        useGrouping: true
                                      }
                                    ).format(totalCost);

                                    // apply red when over budget
                                    const style = {
                                      color:
                                        totalCost > sumDailyBudgets
                                          ? 'red'
                                          : 'inherit'
                                    };

                                    return (
                                      <span style={style}>
                                        {companyCurrency} {formattedCost}
                                      </span>
                                    );
                                  }
                                },
                                {
                                  title: 'Total Budget',
                                  key: 'budget',
                                  render: (_, dayRecord) => {
                                    const companyCurrency =
                                      this.props.sites.find(
                                        s => s._id === this.state.siteSelected
                                      )?.companyCurrency || 'R';
                                    const sumDailyBudgets = (
                                      dayRecord.records || []
                                    ).reduce((sum, rec) => {
                                      if (Array.isArray(rec.dailyBudget)) {
                                        return (
                                          sum +
                                          rec.dailyBudget.reduce(
                                            (s, v) => s + (Number(v) || 0),
                                            0
                                          )
                                        );
                                      }
                                      return (
                                        sum + (Number(rec.dailyBudget) || 0)
                                      );
                                    }, 0);
                                    const formatted = new Intl.NumberFormat(
                                      'en-US',
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                        useGrouping: true
                                      }
                                    ).format(sumDailyBudgets);
                                    return `${companyCurrency} ${formatted}`;
                                  }
                                },
                                {
                                  title: 'Actions',
                                  key: 'actions',
                                  fixed: this.props.isMobile
                                    ? 'right'
                                    : undefined,
                                  width: 96,
                                  render: (_, dayRecord) => {
                                    console.log(
                                      '🟡 Editing/Deleting day row _id:',
                                      dayRecord.records[0]?._id
                                    );

                                    return (
                                      <span>
                                        <Tooltip
                                          placement="top"
                                          title="Edit Day"
                                        >
                                          <EditFilled
                                            style={{
                                              backgroundColor: '#80CE90',
                                              color: 'white',
                                              padding: '0.5em',
                                              borderRadius: '3em'
                                            }}
                                            onClick={e => {
                                              e.stopPropagation(); // Prevent row click event
                                              if (!dayRecord.records[0]?._id) {
                                                console.error(
                                                  '❌ Error: `_id` is undefined!'
                                                ); // 🚨 Debugging step
                                                return;
                                              }
                                              this.handleEditStockCost(
                                                dayRecord.records[0]
                                              ); // ✅ Pass the first record of the day
                                            }}
                                          />
                                        </Tooltip>
                                        <Divider type="vertical" />
                                        <Tooltip
                                          placement="top"
                                          title="Delete Day"
                                        >
                                          <DeleteFilled
                                            style={{
                                              backgroundColor: 'crimson',
                                              color: 'white',
                                              padding: '0.5em',
                                              borderRadius: '3em'
                                            }}
                                            onClick={e => {
                                              e.stopPropagation(); // Prevent row click event
                                              if (!dayRecord.records[0]?._id) {
                                                console.error(
                                                  '❌ Error: `_id` is undefined!'
                                                ); // 🚨 Debugging step
                                                return;
                                              }
                                              this.setState({
                                                deleteVisible: true,
                                                deleteStock:
                                                  dayRecord.records[0] // ✅ Delete day-level record
                                              });
                                            }}
                                          />
                                        </Tooltip>
                                      </span>
                                    );
                                  }
                                }
                              ]}
                            />
                          )
                        }}
                        columns={[
                          {
                            title: 'Month',
                            dataIndex: 'costMonth',
                            key: 'costMonth',
                            render: text => dayjs(text).format('MMM YYYY')
                          },

                          {
                            title: 'Total Rooms Available',
                            dataIndex: ['totals', 'roomsAvail'],
                            key: 'roomsAvail'
                          },
                          {
                            title: 'Total Rooms Booked',
                            dataIndex: ['totals', 'rooms'],
                            key: 'rooms'
                          },
                          {
                            title: 'Average Occupancy %',
                            dataIndex: ['totals', 'occupancy'],
                            key: 'occupancy',
                            render: text => {
                              const occupancyValue = Number(text) || 0; // ✅ Ensure a valid number
                              return `${occupancyValue.toFixed(0)}%`; // ✅ Now `toFixed()` will work
                            }
                          },
                          {
                            title: 'Total PAX',
                            dataIndex: ['totals', 'pax'],
                            key: 'pax'
                          },
                          {
                            title: 'Cost P/Bednight',
                            dataIndex: ['totals', 'totalCostPerPAX'],
                            key: 'totalCostPerPAX',
                            render: text => {
                              const companyCurrency =
                                this.props.sites.find(
                                  site => site._id === this.state.siteSelected
                                )?.companyCurrency || 'R';

                              return `${companyCurrency} ${new Intl.NumberFormat(
                                'en-US',
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }
                              ).format(Number(text) || 0)}`;
                            }
                          },
                          {
                            title: 'Total Cost',
                            dataIndex: ['totals', 'costPrice'],
                            key: 'costPrice',
                            render: text => {
                              const companyCurrency =
                                this.props.sites.find(
                                  site => site._id === this.state.siteSelected
                                )?.companyCurrency || 'R';

                              return `${companyCurrency} ${new Intl.NumberFormat(
                                'en-US',
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }
                              ).format(Number(text) || 0)}`;
                            }
                          }
                        ]}
                      />
                    )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Room Inclusion" key="Complimentary">
                <Row style={{ marginTop: '1em' }}>
                  <Col xs={24} lg={6}>
                    <h1
                      style={{
                        marginBottom: '0em',
                        fontSize: '22px',
                        fontWeight: 800,
                        fontFamily: 'Nunito',
                        marginTop: '0.3em'
                      }}
                    >
                      Room Inclusion
                    </h1>
                  </Col>
                  <Col xs={24} lg={18}>
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '0.6em',
                        justifyContent: this.props.isMobile
                          ? 'flex-start'
                          : 'flex-end',
                        marginTop: this.props.isMobile ? '0.75em' : 0
                      }}
                    >
                      <Select
                        size="large"
                        allowClear
                        placeholder="Category"
                        value={this.state.selectedCompCategory}
                        onChange={value =>
                          this.setState({ selectedCompCategory: value })
                        }
                        style={{
                          width: this.props.isMobile ? '100%' : '12em'
                        }}
                      >
                        {(() => {
                          const configured = [
                            ...new Set(
                              this.props.sites.flatMap(
                                s => s.compCategories || []
                              )
                            )
                          ];
                          const categories = configured.length
                            ? configured
                            : ['Spa', 'Meal', 'Drinks', 'Activity', 'Other'];
                          return categories.map(category => (
                            <Option key={category} value={category}>
                              {category}
                            </Option>
                          ));
                        })()}
                      </Select>
                      <Button
                        type="primary"
                        onClick={this.onAddStockComp}
                        icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                        size="large"
                        style={{
                          flex: this.props.isMobile ? '1 1 auto' : undefined
                        }}
                      >
                        Add Room Inclusion
                      </Button>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: 'black',
                          marginTop: this.props.isMobile ? 0 : '0.3em',
                          marginLeft: this.props.isMobile ? 0 : '0.4em',
                          width: this.props.isMobile ? 44 : undefined,
                          minWidth: this.props.isMobile ? 44 : undefined
                        }}
                        onClick={() =>
                          this.exportCompToExcel(groupedDataComp, compCurrency)
                        }
                      >
                        <DownloadOutlined />
                      </Button>
                    </div>
                  </Col>

                  <Col span={24}>
                    <MobileTableHelp>
                      <strong>SWIPE</strong>
                      Swipe sideways for more columns. Tap + to open details.
                    </MobileTableHelp>
                    <StyledTable
                      className="compact-mobile-table"
                      bordered={false}
                      dataSource={groupedDataComp}
                      rowKey="compMonth"
                      style={{ marginTop: '1em' }}
                      pagination={false}
                      expandable={{
                        expandedRowRender: monthRecord => (
                          <StyledTable
                            bordered={false}
                            dataSource={Object.values(monthRecord.records).sort(
                              (a, b) => a.compDay.localeCompare(b.compDay)
                            )}
                            rowKey="compDay"
                            pagination={false}
                            expandable={{
                              expandedRowRender: dayRecord => (
                                <StyledTable
                                  bordered={false}
                                  dataSource={compLineItems(dayRecord)}
                                  rowKey="key"
                                  pagination={false}
                                  columns={[
                                    {
                                      title: 'Category',
                                      dataIndex: 'compCategory',
                                      key: 'compCategory',
                                      render: text =>
                                        text ? <Tag>{text}</Tag> : '-'
                                    },
                                    {
                                      title: 'Description',
                                      dataIndex: 'compDescription',
                                      key: 'compDescription',
                                      render: text => text || '-'
                                    },
                                    {
                                      title: 'Guest / Room',
                                      dataIndex: 'compGuest',
                                      key: 'compGuest',
                                      render: text => text || '-'
                                    },
                                    {
                                      title: 'Booking Number',
                                      dataIndex: 'compBookingNr',
                                      key: 'compBookingNr',
                                      render: text => text || '-'
                                    },
                                    {
                                      title: 'Comments',
                                      dataIndex: 'compComments',
                                      key: 'compComments',
                                      render: text => text || '-'
                                    },
                                    {
                                      title: 'Value',
                                      dataIndex: 'compValue',
                                      key: 'compValue',
                                      render: text =>
                                        `${compCurrency} ${new Intl.NumberFormat(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        ).format(Number(text) || 0)}`
                                    }
                                  ]}
                                />
                              )
                            }}
                            columns={[
                              {
                                title: 'Day',
                                dataIndex: 'compDay',
                                key: 'compDay',
                                render: text => dayjs(text).format('YYYY-MM-DD')
                              },
                              {
                                title: 'Items',
                                key: 'compCount',
                                render: (text, record) =>
                                  record.totals.compCount
                              },
                              {
                                title: 'Value',
                                key: 'compValue',
                                render: (text, record) =>
                                  `${compCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(record.totals.compValue || 0)}`
                              },
                              {
                                title: 'Actions',
                                key: 'actions',
                                fixed: this.props.isMobile
                                  ? 'right'
                                  : undefined,
                                width: 96,
                                render: (text, dayRecord) => (
                                  <span>
                                    <Tooltip placement="top" title="Edit Day">
                                      <EditFilled
                                        style={{
                                          backgroundColor: '#80CE90',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}
                                        onClick={e => {
                                          e.stopPropagation();
                                          if (!dayRecord.records[0]?._id) {
                                            return;
                                          }
                                          this.handleEditStockComp(
                                            dayRecord.records[0]
                                          );
                                        }}
                                      />
                                    </Tooltip>
                                    <Divider type="vertical" />
                                    <Tooltip placement="top" title="Delete Day">
                                      <DeleteFilled
                                        style={{
                                          backgroundColor: 'crimson',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}
                                        onClick={e => {
                                          e.stopPropagation();
                                          if (!dayRecord.records[0]?._id) {
                                            return;
                                          }
                                          this.setState({
                                            deleteVisible: true,
                                            deleteStock: dayRecord.records[0]
                                          });
                                        }}
                                      />
                                    </Tooltip>
                                  </span>
                                )
                              }
                            ]}
                          />
                        )
                      }}
                      columns={[
                        {
                          title: 'Month',
                          dataIndex: 'compMonth',
                          key: 'compMonth',
                          render: text => dayjs(text + '-01').format('MMM YYYY')
                        },
                        {
                          title: 'Items',
                          key: 'compCount',
                          render: (text, record) => record.totals.compCount
                        },
                        {
                          title: 'Value',
                          key: 'compValue',
                          render: (text, record) =>
                            `${compCurrency} ${new Intl.NumberFormat('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }).format(record.totals.compValue || 0)}`
                        }
                      ]}
                    />
                  </Col>
                </Row>
              </TabPane>
            </StyledTabs>
            </>
          )}
        </Spin>
        <Modal
          title={'Delete ingredient'}
          width={this.props.isMobile ? 'calc(100vw - 2em)' : undefined}
          visible={this.state.deleteVisible}
          onOk={this.handleDeleteStock}
          onCancel={this.cancelDelete}
          okText="Accept"
          cancelText="Cancel"
        >
          <span>Are you sure you want to delete this ingredient?</span>
        </Modal>
      </div>
    );
  }
}

const WrappedStock = Form.create()(withIsMobile(Stock));
export default WrappedStock;
